import {
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Skeleton,
  Space,
  Table,
  Upload,
  message,
} from "antd";
import dayjs from "dayjs";
import CropperImage from "antd-cropper-img";
import editButton from "./styles/img/edit_button.svg";
import "./styles/editAndCreatePartner.css";
import { useState } from "react";
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  PaperClipOutlined,
  DeleteOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import FormItem from "antd/es/form/FormItem";
import UploadLogoPlaceholder from "./styles/img/uploadLogoPlaceholder.svg";
import config from "../../../config";
import TableFilter from "./TableFilter";
import { useEffect } from "react";
import DeletePartnerModal from "./deletePartnerPopup";
import EditCoupon from "./editCoupon";
import { createPartner } from "../../../Utils/createPartner";
import { editPartner } from "../../../Utils/editPartner";
import ValidatePartnerPopup from "./validatePartnerPopup";
import { formatTime } from "../../../Utils/formatTime";
const base_url = config.base_url;

function EditPartnerForm({
  onOk,
  onCancel,
  open,
  userId,
  component,
  setFilteredData,
  setData,
}) {
  const [emailLanguage, setEmailLanguage] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };
  function generateRandomString(length = 8) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [amountPerUser, setAmountPerUser] = useState("money");
  const [customerAmountPerUser, setCustomerAmountPerUser] =
    useState("percentage");
  const [billingDetailsChoice, setBillingDetailsChoice] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  const [fileType, setFileType] = useState("certificateOfInco");
  const [coupon, setCoupon] = useState("percentage");
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [showcouponSection, setShowcouponSection] = useState(false);
  // const [ShowPromotionCard, setShowPromotionCard] = useState(false);
  const [couponExpirationDate, setCouponExpirationDate] = useState(1);
  const [bonusForEach, setBonusForEach] = useState(null);
  const [couponNumbers, setCouponNumbers] = useState("oneCoupon");
  const [hasBonus, setHasBonus] = useState(true);

  const [openEditCoupon, setOpenEditCoupon] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [loadCreateCoupon, setLoadCreateCoupon] = useState(false);
  const [couponsTableLoading, setCouponsTableLoading] = useState(true);
  const [couponsData, setCouponsData] = useState(null);
  const [filteredCouponsData, setFilteredCouponsData] = useState([]);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [editCouponData, setEditCouponData] = useState({});
  const [couponAvailable, setCouponAvailable] = useState(true);
  const [checkCoupon, setCheckCoupon] = useState(false);
  const [checkMultipeCoupon, setCheckMultipeCoupon] = useState(false);
  const [availableEmail, setAvailableEmail] = useState(true);
  /*
    Off by default: a new partner manages nobody until an admin says so.
    Loaded from the partner being edited further down.
  */
  const [canManageCustomers, setCanManageCustomers] = useState(false);
  const [showSuccessfullCouponCreated, setShowSuccessfullCouponCreated] =
    useState(false);
  const [filesForRequest, setFilesForRequest] = useState([]);
  const [uploadedLogo, setUploadedLogo] = useState();
  const [previewLogo, setPreviewLogo] = useState();
  const [uploadedLegalLogo, setUploadedLegalLogo] = useState();
  const [previewLegalLogo, setPreviewLegalLogo] = useState();
  const [logoError, setLogoError] = useState(false);
  const [promotioLogoError, setPromotionLogoError] = useState(false);
  const [openValidationPopup, setOpenValidationPopup] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [editedData, setEditedData] = useState({});
  const [paypalVerified, setPaypalVerified] = useState(false);
  const [paypalCertiticateNameVerified, setPaypalCertiticateNameVerified] =
    useState(false);
  const [bankDetailsVerified, setBankDetailsVerified] = useState(false);
  const [bankCertiticateNameVerified, setBankCertiticateNameVerified] =
    useState(false);
  const [certificateStatementVerified, setCertificateStatementVerified] =
    useState(false);
  const [firstPassword, setFirstPassword] = useState();
  const [userValidated, setUserValidated] = useState(false);
  const [cardType, setCardType] = useState(undefined);
  const [
    showPrefilledTrustedAdvisorContent,
    setshowPrefilledTrustedAdvisorContent,
  ] = useState(undefined);
  const [fillAllFieldsError, setFillAllFieldsError] = useState(false);
  const [expirationDuration, setExpirationDuration] = useState("one_year");
  const [agencyType, setAgencyType] = useState(null);
  const [masterReferralCode, setMasterReferralCode] = useState(undefined);
  const [referralCode1, setreferralCode1] = useState(undefined);
  const [referralCode2, setreferralCode2] = useState(undefined);
  const [referralCode3, setreferralCode3] = useState(undefined);
  const [checkReferralCode1, setCheckReferralCode1] = useState(false);
  const [checkReferralCode2, setCheckReferralCode2] = useState(false);
  const [checkReferralCode3, setCheckReferralCode3] = useState(false);
  const [masterreferralCode1Available, setMasterReferralCode1Available] =
    useState(false);
  const [referralCode1Available, setReferralCode1Available] = useState(false);
  const [referralCode2Available, setReferralCode2Available] = useState(false);
  const [referralCode3Available, setReferralCode3Available] = useState(false);
  const [masterreferralCode1Touched, setMasterReferralCode1Touched] =
    useState(false);
  const [referralCode1Touched, setReferralCode1Touched] = useState(false);
  const [referralCode2Touched, setReferralCode2Touched] = useState(false);
  const [referralCode3Touched, setReferralCode3Touched] = useState(false);
  const [form] = Form.useForm();

  const bankNameChanged = Form.useWatch("account_onwer_name", form);
  const countryChanged = Form.useWatch("country", form);
  const bicChanged = Form.useWatch("bic", form);
  const ibanChanged = Form.useWatch("iban", form);
  const paypalChanged = Form.useWatch("paypal_account", form);
  const masterReferralCodeChanged = Form.useWatch("master_referral_code", form);
  const referralCode1Changed = Form.useWatch("referral_code_1", form);
  const referralCode2Changed = Form.useWatch("referral_code_2", form);
  const referralCode3Changed = Form.useWatch("referral_code_3", form);
  const globalSearchFunction = (value) => {
    setGlobalSearch(value);
  };
  const handleValidationPartnerOk = () => {
    setOpenValidationPopup(false);
  };
  const handleValidationPartnerCancel = () => {
    setOpenValidationPopup(false);
  };
  const handleDeletePartnerOk = () => {
    setOpenDeletePopup(false);
  };
  const handleDeletePartnerCancel = () => {
    setOpenDeletePopup(false);
  };
  const handeEditCouponCancel = () => {
    setOpenEditCoupon(false);
  };
  const handleEditCouponOk = () => {
    setOpenEditCoupon(false);
  };
  const [files, setFiles] = useState([]);

  const generatePassword = () => {
    let charset =
      "!@#$%^&*()0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let newPassword = "";

    for (let i = 0; i < 24; i++) {
      newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setFirstPassword(newPassword);
  };
  const resetEverything = () => {
    setPaymentMethod("paypal");
    setBillingDetailsChoice(1);
    setLoading(true);
    setShowcouponSection(false);
    setCouponNumbers("oneCoupon");
    setCouponExpirationDate(1);
    setCouponsData(null);
    setCertificateStatementVerified(false);
    setBankCertiticateNameVerified(false);
    setBankDetailsVerified(false);
    setPaypalCertiticateNameVerified(false);
    setPaypalVerified(false);
    setAgencyType(null);
    setPreviewLogo(undefined);
    setCardType(undefined);
    setshowPrefilledTrustedAdvisorContent(undefined);
    setPreviewLegalLogo(undefined);
    setLogoError(false);
    setPromotionLogoError(false);
    setUploadedLogo(undefined);
    setUploadedLegalLogo(undefined);
    setMasterReferralCode(undefined);
    setreferralCode1(undefined);
    setreferralCode2(undefined);
    setreferralCode3(undefined);
    setFillAllFieldsError(false);
    setCheckReferralCode1(false);
    setCheckReferralCode2(false);
    setCheckReferralCode3(false);
    setMasterReferralCode1Available(false);
    setReferralCode1Available(false);
    setReferralCode2Available(false);
    setReferralCode3Available(false);
    setMasterReferralCode1Touched(false);
    setReferralCode1Touched(false);
    setReferralCode2Touched(false);
    setReferralCode3Touched(false);
    setCheckCoupon(false);
    setCouponAvailable(false);
    form.resetFields();
  };

  useEffect(() => {
    if (couponsData === null) return;
    const filterTable = couponsData.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(globalSearch.toLowerCase())
      )
    );
    setFilteredCouponsData(filterTable);
  }, [globalSearch]);
  const downloadFile = async (fileId, fileName) => {
    await fetch(base_url + "admin/partners/download/partner/document", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}&file_id=${fileId}`,
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    {
      key: "1",
      title: "Date",
      dataIndex: "date",
    },
    {
      key: "2",
      title: "Uploaded By",
      dataIndex: "upload_by_name",
    },
    {
      key: "3",
      title: "File Type",
      dataIndex: "fileType",
    },
    {
      key: "4",
      title: "File Name",
      dataIndex: "fileName",
    },
    {
      key: "5",
      title: "Download File",
      dataIndex: "download",
      render: (text, record, index) => {
        return (
          <p
            onClick={(e) => {
              downloadFile(record.id, record.fileName);
            }}
            style={{
              textDecoration: "underline",
              color: "rgb(0, 145, 234)",
              margin: "0 0 10px 0",
            }}
          >
            download
          </p>
        );
      },
    },
  ];
  const couponColumns = [
    {
      key: "1",
      title: "Creation Date",
      dataIndex: "created",
      sorter: (a, b) => {
        if (!a.created || !b.created) return;
        return a.created.localeCompare(b.created);
      },
    },
    {
      key: "2",
      title: "Used By",
      dataIndex: "used_by",
      sorter: (a, b) => {
        if (a.used_by === undefined) return;
        if (b.used_by === undefined) return;
        return a.used_by.localeCompare(b.used_by);
      },
    },
    {
      key: "3",
      title: "Coupon Code",
      dataIndex: "code",
      sorter: (a, b) => {
        if (a.code === undefined) return;
        if (b.code === undefined) return;
        return a.code.localeCompare(b.code);
      },
    },
    {
      key: "4",
      title: "Last Modified By",
      dataIndex: "CREATED_BY",
      sorter: (a, b) => {
        if (a.last_modified_by === undefined) return;
        if (b.last_modified_by === undefined) return;
        return a.last_modified_by.localeCompare(b.last_modified_by);
      },
    },
    {
      key: "5",
      title: "Coupon Value",
      dataIndex: "value",
      sorter: (a, b) => {
        if (a.value === undefined) return;
        if (b.value === undefined) return;
        return a.value.localeCompare(b.value);
      },
      render: (text, record) => {
        return (
          <p>
            {record.value} {record.symbol}
          </p>
        );
      },
    },
    {
      key: "6",
      title: "Expiration Date",
      dataIndex: "expiration_date",
      sorter: (a, b) => {
        if (a.expiration_date === undefined) return;
        if (b.expiration_date === undefined) return;
        return a.expiration_date.localeCompare(b.expiration_date);
      },
    },
    {
      key: "7",
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => {
        return;
        if (a.status === undefined) return;
        if (b.status === undefined) return;
        return a.status.localeCompare(b.status);
      },
    },
    {
      key: "8",
      title: "Used date",
      dataIndex: "used_date",
      sorter: (a, b) => {
        if (a.used_date === undefined) return;
        if (b.used_date === undefined) return;
        return a.used_date.localeCompare(b.used_date);
      },
    },
  ];
  const createCopouns = (data, string, totalNumber, status, type) => {
    return fetch(base_url + "admin/partners/validate/coupon", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `coupon=${string}`,
    })
      .then((res) => res.json())
      .then((res) => {
        if (type === "single") {
          setCouponAvailable(res.exist);
          setCheckCoupon(true);
          setLoadCreateCoupon(false);
        }
        if (type === "multipe") {
          setCouponAvailable(res.exist);
          setCheckMultipeCoupon(true);
          setLoadCreateCoupon(false);
        }
        if (res.exists === true) {
          setCouponAvailable(res.exist);
          return;
        }
        let expirationDate;
        if (data.expiration_date_for_copoun) {
          expirationDate = new Date(
            `${data.expiration_date_for_copoun.$d}`
          ).getTime();
        } else expirationDate = "";

        return fetch(base_url + "admin/partners/create/coupon", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `coupon=${string}&totalCoupons=${totalNumber}&expiration_date=${expirationDate}&partner_id=${userId}&customer_reward_percentage=${
            data.coupont_what_customer_get === "percentage"
              ? data.coupont_amount
              : ""
          }&customer_reward_amount=${
            data.coupont_what_customer_get === "amount"
              ? data.coupont_amount
              : ""
          }&customer_reward_time=${
            data.coupont_what_customer_get === "time"
              ? data.coupont_amount * 2629746000
              : ""
          }&valid=${status === "active" ? true : false}`,
        })
          .then((res) => res.json())
          .then((res) => {
            const data = res.data.map((user) => {
              let hasUsed = false;
              let usedDay;
              let usedMonth;
              let usedYear;
              let usedFormat;
              let hasExpiration = false;
              let expirationDay;
              let expirationMonth;
              let expirationYear;
              let expirationFormat;
              let value;
              let symbol;
              let valueLabel;

              if (user.customer_reward_amount !== null) {
                value = user.customer_reward_amount;
                symbol = "$";
                valueLabel = "amount";
              }
              if (user.customer_reward_percentage !== null) {
                value = user.customer_reward_percentage;
                symbol = "%";
                valueLabel = "percentage";
              }
              if (user.customer_reward_time !== null) {
                value = Math.round(user.customer_reward_time / 2629746000);
                symbol = "months";
                valueLabel = "time";
              }
              if (user.expiration_date) {
                hasExpiration = true;
                expirationDay = new Date(user.expiration_date).getDate();
                expirationMonth = new Date(user.expiration_date).getMonth() + 1;
                expirationYear = new Date(user.expiration_date).getFullYear();
                expirationFormat = `${expirationYear}-${expirationMonth}-${expirationDay}`;
              }
              if (user.used_date) {
                hasUsed = true;
                usedDay = new Date(user.created).getDate();
                usedMonth = new Date(user.created).getMonth() + 1;
                usedYear = new Date(user.created).getFullYear();
                usedFormat = `${usedYear}-${usedMonth}-${usedDay}`;
              }
              if (hasUsed && hasExpiration)
                return {
                  ...user,
                  used_date: usedFormat,
                  expiration_date: expirationFormat,
                  created: dayjs(user.CREATED).format("YYYY-MM-DD"),
                  value,
                  symbol,
                  valueLabel,
                };
              else if (hasUsed && !hasExpiration)
                return {
                  ...user,
                  used_date: usedFormat,
                  created: dayjs(user.CREATED).format("YYYY-MM-DD"),
                  value,
                  symbol,
                  valueLabel,
                };
              else if (!hasUsed && hasExpiration)
                return {
                  ...user,
                  expiration_date: expirationFormat,
                  created: dayjs(user.CREATED).format("YYYY-MM-DD"),
                  value,
                  symbol,
                  valueLabel,
                };
              else
                return {
                  ...user,
                  created: dayjs(user.CREATED).format("YYYY-MM-DD"),
                  value,
                  symbol,
                  valueLabel,
                };
            });

            setCouponsTableLoading(false);
            if (type === "single") {
              setCheckCoupon(false);
              setShowSuccessfullCouponCreated(true);
              setTimeout(() => {
                setShowSuccessfullCouponCreated(false);
              }, 3000);
            }
            if (type === "multipe") {
              setCheckMultipeCoupon(false);
              setShowSuccessfullCouponCreated(true);
              setTimeout(() => {
                setShowSuccessfullCouponCreated(false);
              }, 3000);
            }

            setCouponsData(data);
            setFilteredCouponsData(data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoadCreateCoupon(false);
      });
  };
  const handleCreateCoupon = () => {
    if (couponNumbers === "oneCoupon") {
      setLoadCreateCoupon(true);
      form
        .validateFields([
          "coupont_what_customer_get",
          "coupont_amount",
          "single_coupon_string",
          "expiration_date_for_copoun",
          "single_coupon_status",
        ])
        .then((res) => {
          const data = res;

          return createCopouns(
            data,
            res.single_coupon_string,
            1,
            res.single_coupon_status,
            "single"
          );
        })
        .catch((err) => {
          setLoadCreateCoupon(false);
          if (err) return;
        });
    }
    if (couponNumbers === "multipeCoupon") {
      setLoadCreateCoupon(true);
      form
        .validateFields([
          "coupont_what_customer_get",
          "coupont_amount",
          "multipe_coupon_string",
          "expiration_date_for_copoun",
          "multipeCouponCodeNumber",
          "multipe_coupon_status",
        ])
        .then((res) => {
          const data = res;
          return createCopouns(
            data,
            res.multipe_coupon_string,
            res.multipeCouponCodeNumber,
            res.multipe_coupon_status,
            "multipe"
          );
        })
        .catch((err) => {
          setLoadCreateCoupon(false);
          if (err) return;
        });
    }
  };

  const fetchCoupons = (userId) => {
    if (component === "addPartner") {
      setCouponsTableLoading(false);

      return;
    }

    setCouponsTableLoading(true);
    fetch(base_url + "admin/partners/coupons/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}`,
    })
      .then((res) => res.json())
      .then((res) => {
        const data = res.map((user) => {
          let hasUsed = false;
          let usedFormat;
          let hasExpiration = false;
          let expirationFormat;
          let value;
          let symbol;
          let valueLabel;
          let usedBy;
          if (`${user.OFFER}`.includes("%")) {
            value = user.OFFER;
          } else {
            value = formatTime(user.OFFER);
          }

          if (user.EXPIRATION_DATE) {
            hasExpiration = true;

            expirationFormat = dayjs(user.EXPIRATION_DATE).format("YYYY-MM-DD");
          }
          if (user.used_date) {
            hasUsed = true;
            // usedDay = new Date(user.created).getDate();
            // usedMonth = new Date(user.created).getMonth() + 1;
            // usedYear = new Date(user.created).getFullYear();
            usedFormat = dayjs(user.USED_DATE).format("YYYY-MM-DD");
          }
          if (hasUsed && hasExpiration)
            return {
              ...user,
              used_by: user.USED_BY,
              used_date: usedFormat,
              expiration_date: expirationFormat,
              created: dayjs(user.CREATED).format("YYYY-MM-DD"),
              value,
              symbol,
              valueLabel,
              code: user.CODE,
              code_family: user.CODE_FAMILY,
              offer: user.OFFER,
              url: user.URL,
              status: user.VALID,
            };
          else if (hasUsed && !hasExpiration)
            return {
              ...user,
              expiration_date: "-",
              used_by: user.USED_BY,
              used_date: usedFormat,
              created: dayjs(user.CREATED).format("YYYY-MM-DD"),
              value,
              symbol,
              valueLabel,
              code: user.CODE,
              code_family: user.CODE_FAMILY,
              offer: user.OFFER,
              url: user.URL,
              status: user.VALID,
            };
          else if (!hasUsed && hasExpiration)
            return {
              ...user,
              used_date: "-",
              used_by: "unsed",
              expiration_date: expirationFormat,
              created: dayjs(user.CREATED).format("YYYY-MM-DD"),
              value,
              symbol,
              valueLabel,
              code: user.CODE,
              code_family: user.CODE_FAMILY,
              offer: user.OFFER,
              url: user.URL,
              status: user.VALID,
            };
          else
            return {
              ...user,
              expiration_date: "-",
              used_by: "unsed",
              used_date: "-",
              created: dayjs(user.CREATED).format("YYYY-MM-DD"),
              value,
              symbol,
              valueLabel,
              code: user.CODE,
              code_family: user.CODE_FAMILY,
              offer: user.OFFER,
              url: user.URL,
              status: user.VALID,
            };
        });

        setCouponsTableLoading(false);
        setCouponsData(data);
        setFilteredCouponsData(data);
      })
      .catch((err) => {
        // setLoading(false);
        if (err.message === "duplicated") console.log("Code is duplicated");
        setCouponsTableLoading(false);
        console.log(err);
      });
  };

  const fetchData = (userId) => {
    if (component === "addPartner") {
      setLoading(false);
      setExpirationDuration("one_year");
      form.setFieldsValue({
        first_password: firstPassword,
        partner_reward_type: "money",
        customer_reward_type: "percentage",
        bonus: "no",
        billing_details: 1,
        currency: "eur",
        paymentMethod: "paypal",
        file_type: "certificateOfInco",
        account_status: "active",
        coupont_what_customer_get: "discount",
        coupon_expiration_date: 1,
        coupon_numbers: "oneCoupon",
        single_coupon_status: "active",
        multipe_coupon_status: "active",
        subscriptionDuration: "one_year",
        custom_subscription_expiration_date: dayjs(new Date().now),
        master_referral_code: generateRandomString(),
      });
      setHasBonus(false);
      return;
    }

    fetch(base_url + "admin/partners/view/partner", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);

        if (res.promotion_logo && res.promotion_logo.length > 0) {
          let extension = res.promotion_logo[0];
          if (extension === "/") extension = ".jpg";
          else if (extension === "i") extension = ".png";
          const imageUrl = `data:image/${extension};base64,${res.promotion_logo}`;
          setPreviewLogo(imageUrl);
        }
        // TODO: edit for legal_logo
        if (res.legal_advisor_logo && res.legal_advisor_logo.length > 0) {
          let extension = res.legal_advisor_logo[0];
          if (extension === "/") extension = ".jpg";
          else if (extension === "i") extension = ".png";
          const imageUrl = `data:image/${extension};base64,${res.legal_advisor_logo}`;
          setPreviewLegalLogo(imageUrl);
        }
        // setShowPromotionCard(res.show_promotion);
        setLoading(false);
        setUser(res);
        /*
          Seeded from the partner being loaded, beside the other verification
          toggles. The checkbox is not a Form field, so setFieldsValue does not
          fill it -- left out, every edit would post false and quietly take the
          permission away from a partner who had it.
        */
        setCanManageCustomers(res?.can_manage_customers === true);
        setPaypalVerified(res.paypal_verified);
        setBankDetailsVerified(res.bank_details_verified);
        setAgencyType(res.type);
        setCertificateStatementVerified(res.certificate_statement_verified);

        res.billing_method === "paypal"
          ? setPaypalCertiticateNameVerified(res.certiticate_name_verified)
          : setBankCertiticateNameVerified(res.certiticate_name_verified);

        setUserValidated(res.validated);
        res.billing_method && setPaymentMethod(res.billing_method);
        !res.billing_method && setPaymentMethod("paypal");
        setHasBonus(res.has_bonus);
        if (res.billing_method === "paypal") {
          if (res.paypal_verified && res.certiticate_name_verified) {
            setUserValidated(true);
          } else setUserValidated(false);
        }
        if (res.customer_reward_type === null) {
          setCustomerAmountPerUser("percentage");
        }
        if (res.customer_reward_type !== null) {
          setCustomerAmountPerUser(res.customer_reward_type);
        }

        let platformLinks = {};
        res.platform_links.forEach((link) => {
          if (link.platform === "youtube") {
            platformLinks = { ...platformLinks, youtube: link };
          } else if (link.platform === "linkedin") {
            platformLinks = { ...platformLinks, linkedin: link };
          } else if (link.platform === "podCast") {
            platformLinks = { ...platformLinks, podCast: link };
          } else if (link.platform === "tiktok") {
            platformLinks = { ...platformLinks, tiktok: link };
          } else if (link.platform === "facebook") {
            platformLinks = { ...platformLinks, facebook: link };
          } else if (link.platform === "website") {
            platformLinks = { ...platformLinks, website: link };
          } else if (link.platform === "twitter") {
            platformLinks = { ...platformLinks, twitter: link };
          } else if (link.platform === "other") {
            if (!platformLinks.other1) {
              platformLinks = { ...platformLinks, other1: link };
            } else if (!platformLinks.other2) {
              platformLinks = { ...platformLinks, other2: link };
            }
            if (!platformLinks.other3) {
              platformLinks = { ...platformLinks, other3: link };
            }
            if (!platformLinks.other4) {
              platformLinks = { ...platformLinks, other4: link };
            }
            if (!platformLinks.other5) {
              platformLinks = { ...platformLinks, other5: link };
            }
          }
        });

        let customerAmountPerUserr;
        let influencerAmountPerUserr;
        // if (res.customer_reward_type === "percentage") {
        //   customerAmountPerUserr = res.customer_reward_percertange;
        // } else
        if (res.customer_reward_type === "money") {
          customerAmountPerUserr = res.customer_reward_amount;
        } else if (res.customer_reward_type === "time") {
          customerAmountPerUserr = Math.round(
            res.customer_reward_time / 2629746000
          );
        } else if (res.customer_reward_type === "percentage") {
          customerAmountPerUserr = res.customer_reward_percentage;
        } else {
          setCustomerAmountPerUser("nothing");
        }

        if (res.partner_reward_type === "money") {
          influencerAmountPerUserr = res.partner_reward_money;
        } else if (res.partner_reward_type === "time") {
          influencerAmountPerUserr = Math.round(
            res.partner_reward_time / 2629746000
          );
        } else if (res.partner_reward_type === "percentage"){
          setAmountPerUser("percentage")
          influencerAmountPerUserr = res.partner_reward_percentage
        }

        let hasBonus;

        res.has_bonus ? (hasBonus = "yes") : (hasBonus = "no");

        setBonusForEach(res.bonus_customers);
        setBillingDetailsChoice(
          res.billing_method === "paypal" || res.billing_method === "bank"
            ? 2
            : 1
        );
        res.partner_reward_type === undefined && setAmountPerUser("nothing");
        res.customer_reward_type === undefined &&
          setCustomerAmountPerUser("nothing");
        setExpirationDuration("custom");
        setCardType(res.prefilled_customer_data_type);
        setshowPrefilledTrustedAdvisorContent(
          res.prefilled_trustee_advisor ? res.prefilled_trustee_advisor : false
        );

        form.setFieldsValue({
          prefilled_trustee_additional_information:
            res.prefilled_trustee_additional_information,
          partner_as_trusted: res.prefilled_trustee_advisor,
          agency_type: res.agency_type,
          prefilled_customer_data_type: res.prefilled_customer_data_type,
          prefilled_profile: res.prefilled_profile,
          office_email: res.office_email,
          office_phone: res.office_phone,
          office_name: res.office_name,
          office_additional_information: res.office_additional_information,
          office_location: res.office_location,
          subscriptionDuration: "custom",
          custom_subscription_expiration_date: dayjs(res.expiration_date),
          name: res.name === null ? undefined : res.name,
          type:
            res.type === null
              ? undefined
              : res.type === "agency"
              ? "legal advisor"
              : res.type,
          first_password: res.first_password,
          contact_first_name:
            res.contact_first_name === null
              ? undefined
              : res.contact_first_name,
          contact_last_name:
            res.contact_last_name === null ? undefined : res.contact_last_name,
          phone_number:
            res.phone_number === null ? undefined : res.phone_number,
          email_address:
            res.email_address === null ? undefined : res.email_address,
          followers_number:
            res.followers_number === null ? undefined : res.followers_number,
          youtube: platformLinks.youtube ? platformLinks.youtube.link : "",
          podCast: platformLinks.podCast ? platformLinks.podCast.link : "",
          linkedin: platformLinks.linkedin ? platformLinks.linkedin.link : "",
          tiktok: platformLinks.tiktok ? platformLinks.tiktok.link : "",
          facebook: platformLinks.facebook ? platformLinks.facebook.link : "",
          website: platformLinks.website ? platformLinks.website.link : "",
          twitter: platformLinks.twitter ? platformLinks.twitter.link : "",
          other1: platformLinks.other1 ? platformLinks.other1.link : "",
          other2: platformLinks.other2 ? platformLinks.other2.link : "",
          other3: platformLinks.other3 ? platformLinks.other3.link : "",
          other4: platformLinks.other4 ? platformLinks.other4.link : "",
          other5: platformLinks.other5 ? platformLinks.other5.link : "",
          partner_reward_type:
            res.partner_reward_type === undefined
              ? "nothing"
              : res.partner_reward_type,

          customer_reward_type:
            res.customer_reward_type === undefined
              ? "nothing"
              : res.customer_reward_type,

          customer_amount_per_user:
            customerAmountPerUserr === undefined
              ? undefined
              : customerAmountPerUserr,

          influencer_amount_per_user:
            influencerAmountPerUserr === undefined
              ? undefined
              : influencerAmountPerUserr,
          bonus: hasBonus,
          bonus_for_each:
            res.bonus_customers === null ? undefined : res.bonus_customers,
          bonus_will_get:
            res.bonus_money === null ? undefined : res.bonus_money,
          billing_details:
            res.billing_method === "paypal" || res.billing_method === "bank"
              ? 2
              : 1,

          currency: res.currency === undefined ? "eur" : res.currency,
          paymentMethod:
            res.billing_method === undefined ? "paypal" : res.billing_method,
          account_onwer_name:
            res.billing_method === "bank" &&
            res.paypal_account === null &&
            res.bank_owner_name === null
              ? undefined
              : res.bank_owner_name,
          country:
            res.billing_method === "bank" &&
            res.paypal_account === null &&
            res.bank_country === null
              ? undefined
              : res.bank_country,
          bic:
            res.billing_method === "bank" &&
            res.paypal_account === null &&
            res.bank_bic === null
              ? undefined
              : res.bank_bic,
          iban:
            res.billing_method === "bank" &&
            res.paypal_account === null &&
            res.bank_iban === null
              ? undefined
              : res.bank_iban,
          file_type: "certificateOfInco",
          file_type_other: "",
          account_status: res.status === null ? undefined : res.status,
          coupont_what_customer_get: "percentage",
          coupon_expiration_date: 1,
          coupon_numbers: "oneCoupon",
          single_coupon_status: "active",
          multipe_coupon_status: "active",
          expiration_date_for_copoun: dayjs(new Date().now),
          paypal_account: res.paypal_account ? res.paypal_account : undefined,
          promotionPresentedAs: res.promotion_presented_as,
          promotionName: res.promotion_name,
          promotionEmail: res.promotion_email,
          promotionNumber: res.promotion_phone_number,
          promotionAdditionalContent: res.promotion_marketing,
          promotionPhysicalAddress: res.promotion_address,
          prefilled_trustee_additional_information:
            res.prefilled_trustee_additional_information,
        });
        if (res.prefilled_customer_data_type === "legal") {
          form.setFieldsValue({
            legal_website_url: res.website_url,
          });
        } else if (res.prefilled_customer_data_type === "promotion") {
          form.setFieldsValue({
            promotion_website_url: res.website_url,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
    fetch(base_url + "admin/partners/referralsV2/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        res
          .filter((code) => code.master === false)
          .forEach((code, i) => {
            if (code.master) return;

            if (i + 1 === 1) {
              setreferralCode1(code.code);
              setCheckReferralCode1(true);
              form.setFieldsValue({
                referral_code_1: code.code,
              });
            } else if (i + 1 === 2) {
              setCheckReferralCode2(true);
              setreferralCode2(code.code);
              form.setFieldsValue({
                referral_code_2: code.code,
              });
            } else if (i + 1 === 3) {
              setCheckReferralCode3(true);
              setreferralCode3(code.code);
              form.setFieldsValue({
                referral_code_3: code.code,
              });
            }
          });

        res.forEach((code) => {
          if (code.master) {
            setMasterReferralCode(code.code);
            form.setFieldsValue({
              master_referral_code: code.code,
            });
          }
        });
      });
  };

  const handleSubmit = async (values) => {
    const handleValidateCodes = async () => {
      const referralCodesData = form.getFieldsValue([
        "master_referral_code",
        "referral_code_1",
        "referral_code_2",
        "referral_code_3",
      ]);

      if (referralCodesData.master_referral_code) {
        setMasterReferralCode1Touched(true);
        const exists = await validateReferralCode(
          referralCodesData.master_referral_code
        );
        if (exists.exist) {
          setMasterReferralCode1Available(false);
          return false;
        }
        setMasterReferralCode1Available(true);
      }
      if (referralCodesData.referral_code_1) {
        setReferralCode1Touched(true);
        const exists = await validateReferralCode(
          referralCodesData.referral_code_1
        );
        if (exists.exist) {
          setReferralCode1Available(false);
          return false;
        }
        setReferralCode1Available(true);
      }
      if (referralCodesData.referral_code_2) {
        setReferralCode2Touched(true);
        const exists = await validateReferralCode(
          referralCodesData.referral_code_2
        );
        if (exists.exist) {
          setReferralCode2Available(false);
          return false;
        }
        setReferralCode2Available(true);
      }
      if (referralCodesData.referral_code_3) {
        setReferralCode3Touched(true);
        const exists = await validateReferralCode(
          referralCodesData.referral_code_3
        );
        if (exists.exist) {
          setReferralCode3Available(false);
          return false;
        }
        setReferralCode3Available(true);
      } else return true;
    };
    const handleValidateSpecificCode = async (field) => {
      const referralCodesData = form.getFieldsValue([field]);
      if (referralCodesData[field]) {
        const exists = await validateReferralCode(referralCodesData[field]);
        if (exists.exist) {
          return false;
        } else {
          return true;
        }
      }
    };
    const validateChangedCodes = async () => {
      if (
        masterReferralCode !== masterReferralCodeChanged &&
        masterReferralCode
      ) {
        setMasterReferralCode1Touched(true);
        const checkReferralCodesAvail = await handleValidateSpecificCode(
          "master_referral_code"
        );

        if (!checkReferralCodesAvail) {
          setMasterReferralCode1Available(false);
          return false;
        }
        setMasterReferralCode1Available(true);
      }
      if (
        (referralCode1 !== referralCode1Changed &&
          referralCode1 &&
          referralCode1Changed) ||
        (!referralCode1 && referralCode1Changed)
      ) {
        setReferralCode1Touched(true);
        const checkReferralCodesAvail = await handleValidateSpecificCode(
          "referral_code_1"
        );
        if (!checkReferralCodesAvail) {
          setReferralCode1Available(false);
          return false;
        }
        setReferralCode1Available(true);
      }
      if (
        (referralCode2 !== referralCode2Changed &&
          referralCode2 &&
          referralCode2Changed) ||
        (!referralCode2 && referralCode2Changed)
      ) {
        setReferralCode2Touched(true);
        const checkReferralCodesAvail = await handleValidateSpecificCode(
          "referral_code_2"
        );
        if (!checkReferralCodesAvail) {
          setReferralCode2Available(false);
          return false;
        }
        setReferralCode2Available(true);
      }
      if (
        (referralCode3 !== referralCode3Changed &&
          referralCode3 &&
          referralCode3Changed) ||
        (!referralCode3 && referralCode3Changed)
      ) {
        setReferralCode3Touched(true);
        const checkReferralCodesAvail = await handleValidateSpecificCode(
          "referral_code_3"
        );
        if (!checkReferralCodesAvail) {
          setReferralCode3Available(false);
          return false;
        }
        setReferralCode3Available(true);
      }
      return true;
    };
    const editValidatedReferralCode = async () => {
      if (
        masterReferralCode !== masterReferralCodeChanged &&
        masterReferralCode &&
        masterReferralCodeChanged
      ) {
        await editReferralCode(
          userId,
          masterReferralCode,
          masterReferralCodeChanged,
          true
        );
      }
      if (
        referralCode1 !== referralCode1Changed &&
        referralCode1 &&
        referralCode1Changed
      ) {
        await editReferralCode(
          userId,
          referralCode1,
          referralCode1Changed,
          false
        );
      }
      if (
        referralCode2 !== referralCode2Changed &&
        referralCode2 &&
        referralCode2Changed
      ) {
        await editReferralCode(
          userId,
          referralCode2,
          referralCode2Changed,
          false
        );
      }
      if (
        referralCode3 !== referralCode3Changed &&
        referralCode3 &&
        referralCode3Changed
      ) {
        await editReferralCode(
          userId,
          referralCode3,
          referralCode3Changed,
          false
        );
      }
    };
    const createCodeFromEditingComponent = async () => {
      if (
        masterReferralCode !== masterReferralCodeChanged &&
        !masterReferralCode
      ) {
        await createReferralCodeRequest(
          masterReferralCodeChanged,
          userId,
          true
        );
      }
      if (referralCode1 !== referralCode1Changed && !referralCode1) {
        await createReferralCodeRequest(referralCode1Changed, userId, false);
      }
      if (referralCode2 !== referralCode2Changed && !referralCode2) {
        await createReferralCodeRequest(referralCode2Changed, userId, false);
      }
      if (referralCode3 !== referralCode3Changed && !referralCode3) {
        await createReferralCodeRequest(referralCode3Changed, userId, false);
      }
    };
    if (cardType === "promotion" && !previewLogo) {
      if (!previewLogo) {
        setPromotionLogoError(true);
        setFillAllFieldsError(true);

        return;
      }
    } else if (cardType === "legal" && !previewLegalLogo) {
      setLogoError(true);
      setFillAllFieldsError(true);

      return;
    }
    const platform_links = [];
    if (values.youtube) {
      platform_links.push({ platform: "youtube", link: values.youtube });
    }
    if (values.tiktok) {
      platform_links.push({ platform: "tiktok", link: values.tiktok });
    }
    if (values.podcast) {
      platform_links.push({ platform: "podcast", link: values.podcast });
    }
    if (values.twitter) {
      platform_links.push({ platform: "twitter", link: values.twitter });
    }
    if (values.website) {
      platform_links.push({ platform: "website", link: values.website });
    }
    if (values.facebook) {
      platform_links.push({ platform: "facebook", link: values.facebook });
    }
    if (values.other1) {
      platform_links.push({ platform: "other", link: values.other1 });
    }
    if (values.other2) {
      platform_links.push({ platform: "other", link: values.other2 });
    }
    if (values.other3) {
      platform_links.push({ platform: "other", link: values.other3 });
    }
    if (values.other4) {
      platform_links.push({ platform: "other", link: values.other4 });
    }
    if (values.other5) {
      platform_links.push({ platform: "other", link: values.other5 });
    }
    let partner_reward_type;
    let partner_reward_money;
    let partner_reward_time;
    let partner_reward_percentage;

    if (values.partner_reward_type === "money") {
      partner_reward_type = "money";
      partner_reward_money = values.influencer_amount_per_user;
      partner_reward_time = "";
      partner_reward_percentage = ""
    } else if (values.partner_reward_type === "time") {
      partner_reward_type = "time";
      partner_reward_money = "";
      partner_reward_time = values.influencer_amount_per_user * 2629746000;
      partner_reward_percentage = ""
    } else if (values.partner_reward_type === "percentage") {
      partner_reward_type = "percentage";
      partner_reward_money = "";
      partner_reward_time = "";
      partner_reward_percentage = values.influencer_amount_per_user;
    } 
    else {
      partner_reward_type = "";
      partner_reward_time = "";
      partner_reward_money = "";
    }
    let customer_reward_type;
    let customer_reward_money;
    let customer_reward_time;
    let customer_reward_percentage;

    if (values.customer_reward_type === "money") {
      customer_reward_type = "money";
      customer_reward_money = values.customer_amount_per_user;
      partner_reward_time = "";
      customer_reward_percentage = "";
    } else if (values.customer_reward_type === "time") {
      customer_reward_type = "time";
      customer_reward_money = "";
      customer_reward_time = values.customer_amount_per_user * 2629746000;
      customer_reward_percentage = "";
    } else if (values.customer_reward_type === "percentage") {
      customer_reward_type = "percentage";
      customer_reward_money = "";
      customer_reward_time = "";
      customer_reward_percentage = values.customer_amount_per_user;
    } else {
      customer_reward_type = "";
      customer_reward_time = "";
      customer_reward_money = "";
      customer_reward_percentage = "";
    }
    let expiration_date;
    if (expirationDuration === "custom") {
      expiration_date = dayjs(
        values.custom_subscription_expiration_date
      ).valueOf();
    } else if (expirationDuration === "six_months") {
      expiration_date = dayjs() + 6 * 2629746000;
    } else if (expirationDuration === "one_year") {
      expiration_date = dayjs() + 12 * 2629746000;
    } else if (expirationDuration === "two_years") {
      expiration_date = dayjs() + 24 * 2629746000;
    } else {
      expiration_date = dayjs() + 12 * 2629746000;
    }

    let data = {
      expiration_date,
      prefilled_trustee_advisor: values.partner_as_trusted,
      prefilled_customer_data_type: values.prefilled_customer_data_type,
      type: values.type,
      prefilled_profile: values.prefilled_profile,
      agency_type: values?.agency_type,
      office_email: values?.office_email,
      office_phone: values?.office_phone,
      office_name: values?.office_name,
      office_location: values?.office_location,
      office_additional_information: values?.office_additional_information,
      status: values.account_status,
      // Posted as multipart, so it arrives as the string "true"/"false" and is
      // normalised back to a boolean in Routes/Partners.js.
      can_manage_customers: canManageCustomers,
      name: values.name,
      contact_first_name: values.contact_first_name,
      contact_last_name: values.contact_last_name,
      phone_number: values.phone_number,
      email_address: values.email_address?.toLowerCase(),
      first_password: values.first_password,
      followers_number: values.followers_number ? values.followers_number : "",
      platform_links: platform_links,
      currency: values.currency ? values.currency : "",
      billing_method: values.paymentMethod,
      bank_owner_name: values.account_onwer_name
        ? values.account_onwer_name
        : "",
      bank_country: values.country ? values.country : "",
      bank_bic: values.bic ? values.bic : "",
      bank_iban: values.iban ? values.iban : "",

      partner_reward_type: partner_reward_type,
      partner_reward_money: partner_reward_money,
      partner_reward_time: partner_reward_time,
      partner_reward_percentage:partner_reward_percentage,

      customer_reward_type: customer_reward_type ? customer_reward_type : "",
      customer_reward_percentage: customer_reward_percentage,
      customer_reward_amount: customer_reward_money,
      customer_reward_time: customer_reward_time,
      bonus_customers: values.bonus_for_each,
      bonus_money: values.bonus_will_get,
      bonus_time: "",
      paypal_account: values.paypal_account,
      files: filesForRequest,

      bank_details_verified: bankDetailsVerified,
      certificate_statement_verified: certificateStatementVerified,

      paypal_verified: paypalVerified,
      certiticate_name_verified:
        paymentMethod === "bank"
          ? bankCertiticateNameVerified
          : paypalCertiticateNameVerified,
      validated:
        paymentMethod === "bank" &&
        bankCertiticateNameVerified &&
        certificateStatementVerified &&
        bankDetailsVerified
          ? true
          : paymentMethod === "paypal" &&
            paypalCertiticateNameVerified &&
            paypalVerified
          ? true
          : false,
      has_bonus: hasBonus,
      // show_promotion: agencyType === "other" ? ShowPromotionCard : undefined,
    };
    if (showPrefilledTrustedAdvisorContent === true) {
      data.prefilled_trustee_additional_information =
        values.prefilled_trustee_additional_information;
    }
    const allDataUploaded = [...files];
    if (cardType === "promotion") {
      data.promotion_presented_as = values.promotionPresentedAs;
      data.promotion_name = values.promotionName;
      data.promotion_email = values.promotionEmail;
      data.promotion_phone_number = values.promotionNumber;
      data.promotion_marketing = values.promotionAdditionalContent;
      data.promotion_address = values.promotionPhysicalAddress;
      data.website_url = values.promotion_website_url?.trim();
    }
    if (cardType === "promotion") {
      if (uploadedLogo) {
        data.files = [
          ...filesForRequest,
          {
            fileType: "promotion_logo",
            fileName: uploadedLogo.name,
          },
        ];
      } else {
        if (component === "edit" && !previewLogo) {
          await fetch(base_url + "admin/partners/delete/partner/file", {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json, text/plain, /",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
            body: `partner_id=${userId}&file_id=promotion_logo`,
          });
        }
      }
    }
    if (cardType === "legal") {
      data.website_url = values.legal_website_url?.trim();
      if (uploadedLegalLogo) {
        data.files = [
          ...filesForRequest,
          {
            fileType: "legal_advisor_logo",
            fileName: uploadedLegalLogo.name,
          },
        ];
      } else {
        if (component === "edit" && !previewLegalLogo) {
          await fetch(base_url + "admin/partners/delete/partner/file", {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json, text/plain, /",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
            body: `partner_id=${userId}&file_id=legal_advisor_logo`,
          });
        }
      }
    }

    uploadedLogo && allDataUploaded.push(uploadedLogo);
    uploadedLegalLogo && allDataUploaded.push(uploadedLegalLogo);

    setButtonLoading(true);
    if (component === "addPartner") {
      await fetch(base_url + "admin/partners/validate/email", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, /",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        credentials: "include",
        body: `email_address=${data.email_address}`,
      })
        .then(async (res) => {
          if (res.statusText !== "OK") {
            setAvailableEmail(false);
            setLoading(false);
            setButtonLoading(false);
            setFillAllFieldsError(false);
            return;
          }
          setAvailableEmail(true);
          const checkReferralCodesAvail = await handleValidateCodes();
          if (!checkReferralCodesAvail) {
            setLoading(false);
            setButtonLoading(false);
            setFillAllFieldsError(true);

            return;
          }
          createPartner(allDataUploaded, data)
            .then((res) => res.json())
            .then(async (res) => {
              await createReferralCode(res.user_id);
              setData((prev) => [
                {
                  ...res,
                  date: dayjs(res.date).format("YYYY-MM-DD"),
                  index: prev.length + 1,
                },
                ...prev,
              ]);

              setFilteredData((prev) => [
                {
                  ...res,
                  date: dayjs(res.date).format("YYYY-MM-DD"),
                  index: prev.length + 1,
                },
                ...prev,
              ]);
              setFiles([]);
              setFilesForRequest([]);
              onOk();
              success("Partner Created Successfully");
              setButtonLoading(false);
              setCertificateStatementVerified(false);
              setBankCertiticateNameVerified(false);
              setBankDetailsVerified(false);
              setPaypalCertiticateNameVerified(false);
              setPaypalVerified(false);
              setFillAllFieldsError(false);
              setExpirationDuration("one_year");
              setPaymentMethod("paypal");
              setBillingDetailsChoice(1);
              setCardType(undefined);
              setPreviewLegalLogo(undefined);
              setPreviewLogo(undefined);
              resetEverything();
            });
        })

        .catch((err) => {
          setButtonLoading(false);
          setCertificateStatementVerified(false);
          setBankCertiticateNameVerified(false);
          setBankDetailsVerified(false);
          setPaypalCertiticateNameVerified(false);
          setPaypalVerified(false);
          setFillAllFieldsError(false);
          console.log(err);
        });
    } else if (component === "edit") {
      const validatingChangedReferrals = await validateChangedCodes();
      if (!validatingChangedReferrals) {
        setLoading(false);
        setButtonLoading(false);
        setFillAllFieldsError(true);
        return;
      }

      if (!values.paypal_account) data.paypal_account = "";
      if (!values.paymentMethod) data.billing_method = "";

      await editPartner(allDataUploaded, { ...data, partner_id: userId })
        .then((res) => res.json())
        .then(async (res) => {
          console.log(res);
          await editValidatedReferralCode();
          await createCodeFromEditingComponent();
          if (referralCode1 && !referralCode1Changed) {
            await deleteReferralCode(userId, referralCode1);
          }
          if (referralCode2 && !referralCode2Changed) {
            await deleteReferralCode(userId, referralCode2);
          }
          if (referralCode3 && !referralCode3Changed) {
            await deleteReferralCode(userId, referralCode3);
          }

          setData((prev) => {
            const newState = prev.map((obj) => {
              if (obj.user_id === res.user_id) {
                return res;
              }
              return obj;
            });

            return newState;
          });
          setFilteredData((prev) => {
            const newState = prev.map((obj) => {
              if (obj.user_id === res.user_id) {
                return { ...res, index: obj.index };
              }
              return obj;
            });

            return newState;
          });
          setFiles([]);
          setFilesForRequest([]);
          setUser(res);
          setButtonLoading(false);
          onOk();
          setFillAllFieldsError(false);
          setPaymentMethod("paypal");
          setBillingDetailsChoice(1);
          success("Partner Edited Successfully");
          resetEverything();
        })
        .catch((err) => {
          console.log(err);
          setButtonLoading(false);
          setFillAllFieldsError(false);
        });
    } else return;
  };
  useEffect(() => {
    form.setFieldsValue({
      first_password: firstPassword,
    });
  }, [firstPassword]);

  const sendLinkToPartner = (emailLanguage) => {
    fetch(base_url + "admin/partners/welcome/partner", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}&language=${emailLanguage}`,
    }).then((res) => {
      success("Email Sent");
    });
  };
  const validateReferralCode = async (code) => {
    return fetch(base_url + "admin/partners/validate/coupon", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `coupon=${code}`,
    }).then((res) => res.json().then((res) => res));
  };
  const createReferralCodeRequest = async (
    code,
    partner_id,
    master = false
  ) => {
    return fetch(base_url + "admin/partners/referralsV2/create", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `code=${code}&master=${master}&partner_id=${partner_id}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
      });
  };
  const createReferralCode = async (partner_id) => {
    const data = form.getFieldsValue([
      "master_referral_code",
      "referral_code_1",
      "referral_code_2",
      "referral_code_3",
    ]);
    if (data.master_referral_code) {
      await createReferralCodeRequest(
        data.master_referral_code,
        partner_id,
        true
      );
    }
    if (data.referral_code_1) {
      await createReferralCodeRequest(data.referral_code_1, partner_id);
    }
    if (data.referral_code_2) {
      await createReferralCodeRequest(data.referral_code_2, partner_id);
    }
    if (data.referral_code_3) {
      await createReferralCodeRequest(data.referral_code_3, partner_id);
    }
  };
  const editReferralCode = async (partner_id, code, new_code, master) => {
    return fetch(base_url + "admin/partners/referralsV2/edit", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `code=${code}&master=${master}&partner_id=${partner_id}&new_code=${new_code}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
      });
  };
  const deleteReferralCode = async (partner_id, code) => {
    return fetch(base_url + "admin/partners/referralsV2/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `code=${code}&partner_id=${partner_id}`,
    }).then((res) => res.json().then((res) => res));
  };

  return (
    <Modal
      afterOpenChange={(e) => {
        if (e === true && component === "addPartner") {
          generatePassword();
        }
        if (e === true) {
          fetchData(userId);
          fetchCoupons(userId);
        }
        if (e === false) {
          setAvailableEmail(true);
          setButtonLoading(false);
          setLoading(true);
          setPasswordVisible(false);
          setExpirationDuration("one_year");
        }
      }}
      className="editModal"
      open={open}
      onCancel={(e) => {
        resetEverything();
        onCancel();
      }}
      onOk={(e) => {
        resetEverything();
        form.submit();
        onOk();
      }}
      footer={[
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            height: "41px",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "15px",
            }}
          >
            <Button
              onClick={(e) => setOpenDeletePopup(true)}
              className="footerDelete"
              key="delete"
            >
              Delete Partner
            </Button>
            {component === "addPartner" ? (
              <Button disabled className="footerSendLink" key="send_link">
                Send a link to the Partner
              </Button>
            ) : (
              <Button
                onClick={(e) => {
                  sendLinkToPartner(emailLanguage);
                }}
                disabled={emailLanguage == "" || undefined ? true : false}
                className="footerSendLink"
                key="send_link"
              >
                Send a link to the Partner
              </Button>
            )}
            <Select
              defaultValue={emailLanguage}
              onChange={(e) => {
                setEmailLanguage(e);
              }}
              style={{
                height: "32px",
                width: "fit-content",
              }}
            >
              <Select.Option value="" disabled hidden>
                Email Language
              </Select.Option>
              <Select.Option value="fr">French</Select.Option>
              <Select.Option value="en">English</Select.Option>
            </Select>
            {/* {component !== "addPartner" && (
              <Button
                onClick={(e) => {
                  setOpenValidationPopup(true);
                }}
                className="footerButtonSave"
                key="validate_link"
              >
                Approve Partner
              </Button>
            )} */}
          </div>
          <div
            style={{
              display: "flex",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              onClick={(e) => {
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              loading={buttonLoading}
              onClick={(e) => {
                form.submit();
              }}
              htmlType="submit"
              className="footerButtonSave"
              key="save"
            >
              save
            </Button>
          </div>
          {fillAllFieldsError && (
            <p
              style={{
                margin: "0",
                position: "absolute",
                right: "0",
                bottom: "-15px",
                color: "red",
                fontSize: "12px",
              }}
            >
              Please fill all missing mandatory fields
            </p>
          )}
          {!availableEmail &&
            component === "addPartner" &&
            !fillAllFieldsError && (
              <p
                style={{
                  margin: "0",
                  position: "absolute",
                  right: "0",
                  bottom: "-15px",
                  color: "red",
                  fontSize: "12px",
                }}
              >
                Dublicated Email, try another one
              </p>
            )}
        </div>,
      ]}
    >
      <Skeleton
        loading={loading}
        paragraph={{
          rows: 20,
        }}
      />
      {!loading && (
        <>
          <ValidatePartnerPopup
            onCancel={handleValidationPartnerCancel}
            onOk={handleValidationPartnerOk}
            open={openValidationPopup}
          />
          <DeletePartnerModal
            onCancel={handleDeletePartnerCancel}
            open={openDeletePopup}
            onOk={handleDeletePartnerOk}
            userName={user.name}
            userId={userId}
            setFilteredData={setFilteredData}
            setData={setData}
            closeModal={onOk}
          />
          <EditCoupon
            onOk={handleEditCouponOk}
            onCancel={handeEditCouponCancel}
            originalData={editCouponData}
            open={openEditCoupon}
            userId={userId}
            setCouponsData={setCouponsData}
            setFilteredCouponsData={setFilteredCouponsData}
          />

          <Form
            // onValuesChange={(e) => {
            //   if (e.billing_details) {
            //     console.log(1);
            //   }
            //   setEditedData((prev) => {
            //     return { ...prev, ...e };
            //   });
            // }}
            onFinish={handleSubmit}
            className="modalWrapper"
            form={form}
            scrollToFirstError
            onFinishFailed={(e) => {
              if (!previewLogo && cardType === "promotion") {
                setPromotionLogoError(true);
              }
              if (!previewLegalLogo && cardType === "legal") {
                setLogoError(true);
              }

              if (e.errorFields.length >= 1) {
                setFillAllFieldsError(true);
              }
            }}
          >
            <div
              className="title"
              style={{
                gap: "10px",
                textTransform: "capitalize",
              }}
            >
              <h2>{user.name} Details</h2>
              {user.validated === "false" && (
                <h2
                  style={{
                    color: "red",
                  }}
                >
                  Unvalidated
                </h2>
              )}
              {user.validated === "true" && (
                <h2
                  style={{
                    color: "rgba(65, 159, 35, 1)",
                  }}
                >
                  Validated
                </h2>
              )}
            </div>
            <div className="section1">
              <div className="section1Left">
                <p className="section1Left-subtitle">Contact Details</p>
                <Form.Item
                  required
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"name"}
                  label="Partner Name / Company / Brand Name"
                  rules={[
                    { required: true, message: "Please enter partner name" },
                  ]}
                >
                  <Input className="formInput" />
                </Form.Item>
                <Form.Item
                  required
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"type"}
                  label="Partner Type"
                  rules={[
                    { required: true, message: "Please choose partner type" },
                  ]}
                >
                  {component === "edit" ? (
                    <Input
                      disabled={component === "edit"}
                      className="formInput"
                      style={{
                        height: "46px",
                        textTransform: "capitalize",
                      }}
                    ></Input>
                  ) : (
                    <Select
                      onChange={(e) => {
                        setAgencyType(e.toLowerCase());
                      }}
                      style={{
                        height: "46px",
                      }}
                      defaultValue={"Choose"}
                    >
                      <Select.Option value="influencer">
                        Influencer
                      </Select.Option>
                      <Select.Option value="agency">
                        Legal advisor
                      </Select.Option>
                      <Select.Option value="other">Other</Select.Option>
                    </Select>
                  )}
                </Form.Item>

                <Form.Item
                  required
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"contact_first_name"}
                  label="Contact First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter contact first name",
                    },
                  ]}
                >
                  <Input className="formInput" />
                </Form.Item>
                <Form.Item
                  required
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"contact_last_name"}
                  label="Contact Last Name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter contact last name",
                    },
                  ]}
                >
                  <Input className="formInput" />
                </Form.Item>
                <Form.Item
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"phone_number"}
                  label="Contact Phone Number"
                  rules={[
                    {
                      pattern: /^[0-9-+()]*$/,
                      message: "field does not accept alphabetic",
                    },
                  ]}
                >
                  <Input className="formInput" />
                </Form.Item>
                <div>
                  <Form.Item
                    required
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"email_address"}
                    label="Partner Email Address (for login)"
                    validateTrigger="onBlur"
                    rules={[
                      {
                        type: "email",
                        message: "Invalid email address",
                      },
                      {
                        required: true,
                        message: "Email is required",
                      },
                    ]}
                  >
                    <Input
                      disabled={component === "addPartner" ? false : true}
                      onChange={(e) => {
                        form.setFieldsValue({
                          email_address: e.target.value.trim().toLowerCase(),
                        });

                        setAvailableEmail(true);
                      }}
                      className="formInput"
                    />
                  </Form.Item>
                  {!availableEmail && component === "addPartner" && (
                    <p
                      style={{
                        color: "red",
                      }}
                    >
                      Dublicated Email, try another one
                    </p>
                  )}
                </div>
                <p className="section1Left-subtitle">
                  First Temporary Password
                </p>
                <Form.Item
                  required
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"first_password"}
                  label="Login Password"
                  rules={[
                    {
                      required: true,
                      message: "password is required",
                    },
                    {
                      type: "password",
                    },
                  ]}
                  style={{
                    width: "120% !important",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      backgroundColor: "rgba(247, 247, 247, 1) !important",
                    }}
                  >
                    <Input.Password
                      defaultValue={
                        user.first_password === undefined
                          ? firstPassword
                          : user.first_password
                      }
                      className="formInput"
                      disabled={component === "addPartner" ? false : true}
                      visibilityToggle={{
                        visible: passwordVisible,
                        onVisibleChange: setPasswordVisible,
                      }}
                      iconRender={(visible) => (visible ? <></> : <></>)}
                    ></Input.Password>
                    {passwordVisible ? (
                      <EyeOutlined
                        style={{
                          transform: "translateX(-50px)",
                          zIndex: "15",
                        }}
                        onClick={() =>
                          setPasswordVisible((prevState) => !prevState)
                        }
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        style={{
                          transform: "translateX(-50px)",
                          zIndex: "15",
                        }}
                        onClick={() =>
                          setPasswordVisible((prevState) => !prevState)
                        }
                      />
                    )}
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          form.getFieldValue(["first_password"])
                        );
                        success("Text Copied");
                      }}
                      style={{
                        transform: "translateX(-35px)",
                        zIndex: "15",
                        color: "rgb(0, 145, 234)",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Form.Item>
              </div>
              <div className="section1Right">
                <p className="section1Left-subtitle">Influencer Data</p>
                <div
                  style={{
                    display: "flex",
                    gap: "25px",
                  }}
                >
                  <Form.Item
                    className="formLabel"
                    style={{
                      width: "50%",
                    }}
                    labelCol={{ span: 24 }}
                    name={"followers_number"}
                    label="Number Of Followers/Customers"
                  >
                    <Input className="formInput" />
                  </Form.Item>
                  <Form.Item
                    className="formLabel"
                    style={{
                      width: "50%",
                    }}
                    //TODO: it should be required but i won't allow it because it is not ready yet

                    required
                    rules={[
                      {
                        required: true,
                        message: "Prefilled profile can not be empty",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    name={"prefilled_profile"}
                    label="Choose Prefilled data profile"
                  >
                    <Select
                      // disabled={component === "edit"}
                      style={{
                        height: "46px",
                      }}
                      defaultValue={"Choose"}
                    >
                      <Select.Option value="none">None</Select.Option>
                      <Select.Option value="default">Default</Select.Option>
                      {/* TODO: add other values */}
                    </Select>
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "25px",
                  }}
                >
                  <Form.Item
                    className="formLabel"
                    style={{
                      width: "50%",
                    }}
                    required
                    rules={[
                      {
                        required: true,
                        message: "Please selec a card type",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    name={"prefilled_customer_data_type"}
                    label="Add a legal or promo card?"
                  >
                    <Select
                      // disabled={component === "edit"}
                      defaultValue="Choose"
                      style={{
                        height: "46px",
                      }}
                      onChange={(e) => {
                        setCardType(e);
                      }}
                    >
                      <Select.Option value="legal">Legal card</Select.Option>
                      <Select.Option value="promotion">
                        Promotion card
                      </Select.Option>
                      <Select.Option value="none">None</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    className="formLabel"
                    style={{
                      width: "50%",
                    }}
                    required
                    rules={[
                      {
                        required: true,
                        message: "Please choose a value",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    name={"partner_as_trusted"}
                    label="Insert the partner’s data as trusted advisor?"
                  >
                    <Select
                      // disabled={component === "edit"}
                      defaultValue={"Choose"}
                      style={{
                        height: "46px",
                      }}
                      onChange={(e) => {
                        setshowPrefilledTrustedAdvisorContent(e);
                      }}
                    >
                      <Select.Option value={true}>Yes</Select.Option>
                      <Select.Option value={false}>No</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                {cardType === "none" && (
                  <>
                    <p
                      style={{
                        fontWeight: "500",
                      }}
                    >
                      Influencer Main Platform Link
                    </p>
                    <div className="section1Right_wrapper">
                      <div className="section1Right_wrapper_left">
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"youtube"}
                          label="Youtube"
                          // rules={[
                          //   {
                          //     required: false,
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"podcast"}
                          label="PodCast"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"linkedin"}
                          label="LinkedIn"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"twitter"}
                          label="X(Twitter)"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"tiktok"}
                          label="TikTok"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"facebook"}
                          label="Facebook"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                      </div>
                      <div className="section1Right_wrapper_right">
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"website"}
                          label="Website"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"other1"}
                          label="Other"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"other2"}
                          label="Other"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"other3"}
                          label="Other"
                          rules={[
                            {
                              type: "url",
                              message: "This field must be a valid url.",
                            },
                          ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"other4"}
                          label="Other"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                        <Form.Item
                          validateTrigger="onBlur"
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"other5"}
                          label="Other"
                          // rules={[
                          //   {
                          //     type: "url",
                          //     message: "This field must be a valid url.",
                          //   },
                          // ]}
                        >
                          <Input className="formInput" />
                        </Form.Item>
                      </div>
                    </div>
                  </>
                )}
                {cardType === "legal" && (
                  <>
                    <p
                      style={{
                        fontWeight: "500",
                      }}
                    >
                      Legal card
                    </p>
                    <div
                      className="section1Right_wrapper"
                      style={{
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          position: "relative",
                        }}
                      >
                        <Form.Item
                          style={{
                            width: "100%",
                          }}
                          required
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name={"agency_type"}
                          label="Presented as"
                          rules={[
                            {
                              required: true,
                              message: "Please choose the agency type",
                            },
                          ]}
                        >
                          <Input
                            showCount
                            maxLength={30}
                            // disabled={component === "edit"}
                            styles={{
                              backgroundColor: "red !important",
                            }}
                            className="formInput showCount"
                            style={{
                              height: "46px",
                            }}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Form.Item
                            className="formLabel"
                            style={{}}
                            labelCol={{ span: 24 }}
                            label="Upload Legal logo"
                            required={true}
                          ></Form.Item>
                          <CropperImage
                            dragMode="move"
                            rotatable={true}
                            zoomSlider={false}
                            zoomOnTouch={false}
                            wheelZoomRatio={0.2}
                            zoomOnWheel={true}
                            quality={0.4}
                            classNames={"xxx"}
                            scalable={true}
                            cropShape="round"
                            restore={true}
                          >
                            <Upload
                              // disabled={!ShowPromotionCard}
                              className="uploadLogo"
                              accept=".jpg, .jpeg, .png"
                              multiple={false}
                              maxCount={1}
                              beforeUpload={(file) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = (e) => {
                                  setPreviewLegalLogo(reader.result);
                                };
                                setUploadedLegalLogo(file);
                                setLogoError(false);
                                // Prevent upload
                                return false;
                              }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                { remove }
                              ) => {
                                return null;
                              }}
                            >
                              {!previewLegalLogo && (
                                <div
                                  style={{
                                    bottom: "0px",
                                  }}
                                  // disabled={component === "edit"}
                                  className="promotionUploadContainer"
                                >
                                  <img
                                    src={UploadLogoPlaceholder}
                                    alt="uploadlogo"
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      bottom: "-15px",
                                      right: "-25px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      width: "max-content",
                                    }}
                                  >
                                    Upload Legal logo
                                  </span>
                                </div>
                              )}
                              {previewLegalLogo && (
                                <img
                                  // disabled={component === "edit"}
                                  src={editButton}
                                  alt="edit"
                                  style={{
                                    bottom: "-5px",
                                  }}
                                  className="editButton"
                                />
                              )}
                            </Upload>
                          </CropperImage>
                          <>
                            {previewLegalLogo && (
                              <div
                                // disabled={component === "edit"}
                                className="promotionUploadContainer"
                                style={{
                                  bottom: "0px",
                                }}
                              >
                                <img
                                  className="previewImage"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                  }}
                                  src={previewLegalLogo}
                                  alt="uploadedLegalLogo"
                                />
                                <div className={"displayDeleteIcon"}>
                                  <div className={"deletBackdrop"} />
                                  <div className={"deleteIcon"}>
                                    <DeleteOutlined
                                      onClick={(e) => {
                                        // remove(file);
                                        setUploadedLegalLogo(undefined);
                                        setPreviewLegalLogo(undefined);
                                        setLogoError(true);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {logoError && (
                              <p
                                style={{
                                  position: "absolute",
                                  bottom: "-30px",
                                  right: "-80px",
                                }}
                                className="errorMessage"
                              >
                                Please upload logo image
                              </p>
                            )}
                          </>
                        </div>
                      </div>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"office_name"}
                        label="Office Name"
                        validateTrigger="onBlur"
                        required
                        rules={[
                          {
                            required: true,
                            message: "name is required",
                          },
                        ]}
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"office_email"}
                        label="Office Email Address"
                        validateTrigger="onBlur"
                        required
                        rules={[
                          {
                            type: "email",
                            message: "Invalid email address",
                          },
                          {
                            required: true,
                            message: "Email is required",
                          },
                        ]}
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"office_phone"}
                        label="Office Phone Number"
                        validateTrigger="onBlur"
                        required
                        rules={[
                          {
                            required: true,
                            message: "Phone number is required",
                          },
                          {
                            pattern: /^[0-9-+()]*$/,
                            message: "field does not accept alphabetic",
                          },
                        ]}
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"office_location"}
                        label="Office Address"
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"legal_website_url"}
                        label="Website URL"
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"office_additional_information"}
                        label="Additional Information"
                      >
                        <Input.TextArea
                          // disabled={component === "edit"}
                          autoSize={{
                            minRows: 3,
                            maxRows: 3,
                          }}
                          className="formInput"
                        />
                      </Form.Item>
                    </div>
                  </>
                )}
                {cardType === "promotion" && (
                  <>
                    {/* <Checkbox
                      checked={ShowPromotionCard}
                      style={{ marginBottom: "10px" }}
                      onChange={(e) => {
                        // setShowPromotionCard(e.target.checked);
                      }}
                    >
                      Present Partner’s promotion card
                    </Checkbox> */}
                    <p
                      style={{
                        fontWeight: "500",
                      }}
                    >
                      Promotion card
                    </p>
                    <div
                      className="section1Right_wrapper"
                      style={{
                        flexDirection: "column",
                        gap: "0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                        }}
                      >
                        <Form.Item
                          className="formLabel"
                          style={{
                            width: "107%",
                          }}
                          labelCol={{ span: 24 }}
                          name={"promotionPresentedAs"}
                          label="Presented as"
                          validateTrigger="onBlur"
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: "Presented as field is required",
                            },
                          ]}
                        >
                          <Input
                            // disabled={component === "edit"}
                            className="formInput"
                            showCount
                            maxLength={30}
                          />
                        </Form.Item>

                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Form.Item
                            className="formLabel"
                            required
                            labelCol={{ span: 24 }}
                            label="Upload promotion logo"
                          ></Form.Item>
                          <CropperImage
                            dragMode="move"
                            rotatable={true}
                            zoomSlider={false}
                            zoomOnTouch={false}
                            wheelZoomRatio={0.2}
                            zoomOnWheel={true}
                            quality={0.4}
                            classNames={"xxx"}
                            scalable={true}
                            cropShape="round"
                            restore={true}
                          >
                            <Upload
                              className="uploadLogo"
                              accept=".jpg, .jpeg, .png"
                              multiple={false}
                              maxCount={1}
                              beforeUpload={(file) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = (e) => {
                                  setPreviewLogo(reader.result);
                                  // setLogoError(false);
                                  setPromotionLogoError(false);
                                };
                                setUploadedLogo(file);
                                // Prevent upload
                                return false;
                              }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                { remove }
                              ) => {
                                return null;
                              }}
                            >
                              {!previewLogo && (
                                <div
                                  // disabled={!ShowPromotionCard}
                                  className="promotionUploadContainer"
                                >
                                  <img
                                    src={UploadLogoPlaceholder}
                                    alt="uploadlogo"
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      bottom: "-15px",
                                      right: "-45px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      width: "max-content",
                                    }}
                                  >
                                    Upload promotion logo
                                  </span>
                                </div>
                              )}
                              {previewLogo && (
                                <img
                                  // disabled={!ShowPromotionCard}
                                  src={editButton}
                                  alt="edit"
                                  className="editButton"
                                />
                              )}
                            </Upload>
                          </CropperImage>
                          <>
                            {previewLogo && (
                              <div
                                // disabled={!ShowPromotionCard}
                                className="promotionUploadContainer"
                              >
                                <img
                                  className="previewImage"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                  }}
                                  src={previewLogo}
                                  alt="uploadedLogo"
                                />
                                <div className={"displayDeleteIcon"}>
                                  <div className={"deletBackdrop"} />
                                  <div className={"deleteIcon"}>
                                    <DeleteOutlined
                                      onClick={(e) => {
                                        // remove(file);
                                        setUploadedLogo(undefined);
                                        setPreviewLogo(undefined);
                                        setPromotionLogoError(true);
                                      }}
                                    />
                                  </div>
                                </div>
                                {/* {logoError && ShowPromotionCard && (
                                  <p className="errorMessage">
                                    Please upload logo image
                                  </p>
                                )} */}
                              </div>
                            )}
                            {promotioLogoError && (
                              <p
                                style={{
                                  position: "absolute",
                                  bottom: "-80px",
                                  right: "-90px",
                                }}
                                className="errorMessage"
                              >
                                Please upload logo image
                              </p>
                            )}
                          </>
                        </div>
                      </div>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "50%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"promotionName"}
                        label="Partner’s name (title)"
                        validateTrigger="onBlur"
                        required={true}
                        rules={[
                          {
                            required: true,
                            message: "Partner's name is required",
                          },
                        ]}
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "50%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"promotionEmail"}
                        label="Email to present"
                        validateTrigger="onBlur"
                        required={true}
                        rules={[
                          {
                            type: "email",
                            message: "Invalid email address",
                          },
                          {
                            required: true,
                            message: "Pormotion Email is required",
                          },
                        ]}
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "50%",
                        }}
                        required={true}
                        rules={[
                          {
                            required: true,
                            message: "Phone number is required",
                          },
                          {
                            pattern: /^[0-9-+()]*$/,
                            message: "field does not accept alphabetic",
                          },
                        ]}
                        labelCol={{ span: 24 }}
                        name={"promotionNumber"}
                        label="Phone number to present"
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "50%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"promotionPhysicalAddress"}
                        label="Physical Address"
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "50%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"promotion_website_url"}
                        label="Website URL"
                      >
                        <Input
                          // disabled={component === "edit"}
                          className="formInput"
                        />
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        style={{
                          width: "100%",
                        }}
                        labelCol={{ span: 24 }}
                        name={"promotionAdditionalContent"}
                        label="Additional marketing content"
                      >
                        <Input
                          // disabled={component === "edit"}
                          showCount
                          maxLength={130}
                          className="formInput"
                        />
                      </Form.Item>
                      {showPrefilledTrustedAdvisorContent && (
                        <Form.Item
                          className="formLabel"
                          style={{
                            width: "100%",
                          }}
                          required={true}
                          rules={[
                            {
                              required: true,
                              message:
                                "Please fill the trusted advisor description content",
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          name={"prefilled_trustee_additional_information"}
                          label="Pre-filled trusted advisor description content"
                        >
                          <Input.TextArea
                            showCount
                            rows={5}
                            style={{
                              resize: "none",
                              marginBottom: "10px",
                            }}
                            // disabled={component === "edit"}
                            className="formInput"
                          />
                        </Form.Item>
                      )}
                      {!showPrefilledTrustedAdvisorContent && (
                        <>
                          <Form.Item
                            className="formLabel"
                            style={{
                              width: "100%",
                            }}
                            labelCol={{ span: 24 }}
                            label="Pre-filled trusted advisor description content"
                          ></Form.Item>
                          <div
                            style={{
                              width: "100%",
                              height: "120px",
                              backgroundColor: "#0886d412 ",
                              borderRadius: "6px",
                            }}
                            className="prefilledDisabled"
                            disabled={true}
                          />
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <Divider />
            <div className="referralCodesSection">
              <p className="section2Subtitle">Create Referral Codes</p>
              <div className="referralCodeContent">
                <div className="referralCodeRow">
                  <Form.Item
                    style={{
                      width: "max-content",
                    }}
                    className="formLabel referralCodeClass"
                    name={"master_referral_code"}
                    label="Master referral code"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Master code can not be empty",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      style={{
                        width: "265px",
                      }}
                      onChange={(e) => {
                        if (e.target.value.length === 0) {
                          form.setFieldsValue({
                            master_referral_code: undefined,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                  <div className="urlContainer">
                    <p>{`${window.origin}/register/?referral=${
                      masterReferralCodeChanged === undefined
                        ? ""
                        : masterReferralCodeChanged
                    }`}</p>
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          `${window.origin}/register/?referral=${
                            masterReferralCodeChanged === undefined
                              ? ""
                              : masterReferralCodeChanged
                          }`
                        );
                        success("Master referral code Copied");
                      }}
                      style={{
                        color: "rgb(0, 145, 234)",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  {masterreferralCode1Touched &&
                    masterreferralCode1Available && (
                      <div
                        className="couponAvailableWrapper"
                        style={{
                          left: "160px",
                          bottom: "-35px",
                        }}
                      >
                        <CheckCircleFilled
                          style={{ color: "rgba(65, 159, 35, 1)" }}
                        />
                        <p>Available</p>
                      </div>
                    )}
                  {masterreferralCode1Touched &&
                    !masterreferralCode1Available && (
                      <div
                        className="couponAvailableWrapper"
                        style={{
                          left: "160px",
                          bottom: "-35px",
                        }}
                      >
                        <CloseCircleFilled style={{ color: "red" }} />
                        <p>Not Available,Try another name</p>
                      </div>
                    )}
                </div>

                <div className="referralCodeRow">
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCheckReferralCode1(true);
                      }
                      if (
                        component === "addPartner" ||
                        referralCode1 === undefined
                      ) {
                        setCheckReferralCode1(e.target.checked);
                        !e.target.checked &&
                          form.setFieldsValue({
                            referral_code_1: undefined,
                          });
                      }
                    }}
                    style={{
                      position: "absolute",
                      marginBottom: "8px",
                      left: "0",
                      bottom: "10px",
                    }}
                    checked={checkReferralCode1}
                  />
                  <Form.Item
                    style={{
                      width: "max-content",
                    }}
                    className="formLabel referralCodeClass"
                    name={"referral_code_1"}
                    label="Referral code 1"
                    required={checkReferralCode1}
                    rules={[
                      {
                        required: checkReferralCode1,
                        message: "Referral code can not be empty",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      style={{
                        width: "265px",
                      }}
                      disabled={!checkReferralCode1}
                      onChange={(e) => {
                        setReferralCode1Touched(false);
                        if (e.target.value.length === 0) {
                          form.setFieldsValue({
                            referral_code_1: undefined,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                  {checkReferralCode1 && (
                    <>
                      <div className="urlContainer">
                        <p>{`${window.origin}/register/?referral=${
                          referralCode1Changed === undefined
                            ? ""
                            : referralCode1Changed
                        }`}</p>
                        <CopyOutlined
                          onClick={(e) => {
                            navigator.clipboard.writeText(
                              `${window.origin}/register/?referral=${
                                referralCode1Changed === undefined
                                  ? ""
                                  : referralCode1Changed
                              }`
                            );
                            success("Referral code Copied");
                          }}
                          style={{
                            color: "rgb(0, 145, 234)",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </>
                  )}
                  {referralCode1Touched && referralCode1Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CheckCircleFilled
                        style={{ color: "rgba(65, 159, 35, 1)" }}
                      />
                      <p>Available</p>
                    </div>
                  )}
                  {referralCode1Touched && !referralCode1Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CloseCircleFilled style={{ color: "red" }} />
                      <p>Not Available,Try another name</p>
                    </div>
                  )}
                  <p
                    className="deleteReferralCode"
                    onClick={() => {
                      setCheckReferralCode1(false);
                      form.setFieldsValue({ referral_code_1: undefined });
                      setReferralCode1Available(false);
                      setReferralCode1Touched(false);
                    }}
                  >
                    Delete
                  </p>
                </div>
                <div className="referralCodeRow">
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCheckReferralCode2(true);
                      }
                      if (
                        component === "addPartner" ||
                        referralCode2 === undefined
                      ) {
                        setCheckReferralCode2(e.target.checked);
                        !e.target.checked &&
                          form.setFieldsValue({
                            referral_code_2: undefined,
                          });
                      }
                    }}
                    style={{
                      position: "absolute",
                      marginBottom: "8px",
                      left: "0",
                      bottom: "10px",
                    }}
                    checked={checkReferralCode2}
                  />
                  <Form.Item
                    style={{
                      width: "max-content",
                    }}
                    className="formLabel referralCodeClass"
                    name={"referral_code_2"}
                    label="Referral code 2"
                    required={checkReferralCode2}
                    rules={[
                      {
                        required: checkReferralCode2,
                        message: "Referral code can not be empty",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      style={{
                        width: "265px",
                      }}
                      disabled={!checkReferralCode2}
                      onChange={(e) => {
                        setReferralCode2Touched(false);
                        if (e.target.value.length === 0) {
                          form.setFieldsValue({
                            referral_code_2: undefined,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                  {checkReferralCode2 && (
                    <>
                      <div className="urlContainer">
                        <p>{`${window.origin}/register/?referral=${
                          referralCode2Changed === undefined
                            ? ""
                            : referralCode2Changed
                        }`}</p>
                        <CopyOutlined
                          onClick={(e) => {
                            navigator.clipboard.writeText(
                              `${window.origin}/register/?referral=${
                                referralCode2Changed === undefined
                                  ? ""
                                  : referralCode2Changed
                              }`
                            );
                            success("Referral code Copied");
                          }}
                          style={{
                            color: "rgb(0, 145, 234)",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </>
                  )}
                  {referralCode2Touched && referralCode2Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CheckCircleFilled
                        style={{ color: "rgba(65, 159, 35, 1)" }}
                      />
                      <p>Available</p>
                    </div>
                  )}
                  {referralCode2Touched && !referralCode2Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CloseCircleFilled style={{ color: "red" }} />
                      <p>Not Available,Try another name</p>
                    </div>
                  )}
                  <p
                    className="deleteReferralCode"
                    onClick={() => {
                      setCheckReferralCode2(false);
                      form.setFieldsValue({ referral_code_2: undefined });
                      setReferralCode2Available(false);
                      setReferralCode2Touched(false);
                    }}
                  >
                    Delete
                  </p>
                </div>
                <div className="referralCodeRow">
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCheckReferralCode3(true);
                      }
                      if (
                        component === "addPartner" ||
                        referralCode3 === undefined
                      ) {
                        setCheckReferralCode3(e.target.checked);
                        !e.target.checked &&
                          form.setFieldsValue({
                            referral_code_3: undefined,
                          });
                      }
                    }}
                    style={{
                      position: "absolute",
                      marginBottom: "8px",
                      left: "0",
                      bottom: "10px",
                    }}
                    checked={checkReferralCode3}
                  />
                  <Form.Item
                    style={{
                      width: "max-content",
                    }}
                    className="formLabel referralCodeClass"
                    name={"referral_code_3"}
                    label="Referral code 3"
                    required={checkReferralCode3}
                    rules={[
                      {
                        required: checkReferralCode3,
                        message: "Referral code can not be empty",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      style={{
                        width: "265px",
                      }}
                      disabled={!checkReferralCode3}
                      onChange={(e) => {
                        setReferralCode3Touched(false);
                        if (e.target.value.length === 0) {
                          form.setFieldsValue({
                            referral_code_3: undefined,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                  {checkReferralCode3 && (
                    <>
                      <div className="urlContainer">
                        <p>{`${window.origin}/register/?referral=${
                          referralCode3Changed === undefined
                            ? ""
                            : referralCode3Changed
                        }`}</p>
                        <CopyOutlined
                          onClick={(e) => {
                            navigator.clipboard.writeText(
                              `${window.origin}/register/?referral=${
                                referralCode3Changed === undefined
                                  ? ""
                                  : referralCode3Changed
                              }`
                            );
                            success("Referral code Copied");
                          }}
                          style={{
                            color: "rgb(0, 145, 234)",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </>
                  )}
                  {referralCode3Touched && referralCode3Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CheckCircleFilled
                        style={{ color: "rgba(65, 159, 35, 1)" }}
                      />
                      <p>Available</p>
                    </div>
                  )}
                  {referralCode3Touched && !referralCode3Available && (
                    <div
                      className="couponAvailableWrapper"
                      style={{
                        left: "160px",
                        bottom: "-35px",
                      }}
                    >
                      <CloseCircleFilled style={{ color: "red" }} />
                      <p>Not Available,Try another name</p>
                    </div>
                  )}
                  <p
                    className="deleteReferralCode"
                    onClick={() => {
                      setCheckReferralCode3(false);
                      form.setFieldsValue({ referral_code_3: undefined });
                      setReferralCode3Available(false);
                      setReferralCode3Touched(false);
                    }}
                  >
                    Delete
                  </p>
                </div>
              </div>
            </div>
            <Divider />
            <div className="section2">
              <div className="section2_firstrow">
                <p className="section2Subtitle">Partner Offer</p>
                <Checkbox
                  onChange={(e) => {
                    setShowcouponSection(e.target.checked);
                    // if (e.target.checked) {
                    //   if (couponsData !== null) {
                    //     return;
                    //   }
                    //   fetchCoupons(userId);
                    // }
                  }}
                >
                  Generate Specific Code
                </Checkbox>
              </div>
              {showcouponSection && (
                <>
                  <div className="couponRow">
                    <div className="couponRow_firstRow">
                      <Form.Item
                        style={{
                          width: "265px",
                        }}
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name={"coupont_what_customer_get"}
                        label="What the Customer will get"
                        required
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Select
                          style={{
                            height: "46px",
                          }}
                          onChange={(e) => setCoupon(e)}
                        >
                          <Select.Option value="percentage">
                            Discount - percentage
                          </Select.Option>
                          <Select.Option value="time">
                            Free Subscription plan
                          </Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name={"coupont_amount"}
                        label="Amount per user"
                        required
                        style={{
                          width: "200px",
                        }}
                        rules={[
                          {
                            required: true,
                            message: "Enter a valid value",
                          },
                        ]}
                      >
                        {coupon === "amount" && (
                          <InputNumber
                            controls={false}
                            addonBefore="$"
                            className="formInput"
                          />
                        )}
                        {coupon === "percentage" && (
                          <InputNumber
                            controls={false}
                            addonBefore="%"
                            className="formInput"
                          />
                        )}
                        {coupon === "time" && <Input className="formInput" />}
                      </Form.Item>
                      <Form.Item
                        style={{
                          width: "200px",
                        }}
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name={"coupon_expiration_date"}
                        label="Coupon expiration date"
                        required
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => {
                            setCouponExpirationDate(e.target.value);
                            form.setFieldsValue({
                              expiration_date_for_copoun: undefined,
                            });
                          }}
                        >
                          <Space direction="vertical">
                            <Radio value={1}>No expiration date</Radio>
                            <Radio value={2}>Set expiration date: </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                      {couponExpirationDate === 2 ? (
                        <Form.Item
                          style={{
                            transform: "translate(-50px,55px)",
                            width: "206px",
                            height: "46px",
                          }}
                          // className="formLabel"
                          // labelCol={{ span: 24 }}
                          // name={"coupon_expiration_date"}
                          // label="Coupon expiration date"
                          name={"expiration_date_for_copoun"}
                          required
                          rules={[
                            {
                              required: true,
                              message: "choose a valid date",
                            },
                          ]}
                        >
                          <DatePicker
                            allowClear={false}
                            onChange={(date, dateString) => {}}
                            style={{
                              // transform: "translate(-50px,55px)",
                              width: "206px",
                              height: "46px",
                            }}
                            format="YYYY-MM-DD"
                            placeholder="YYYY-MM-DD"
                            disabledDate={(current) => {
                              let customDate = dayjs().format("YYYY-MM-DD");
                              return (
                                current &&
                                current < dayjs(customDate, "YYYY-MM-DD")
                              );
                            }}
                            // defaultValue={dayjs(new Date().now)}
                          />
                        </Form.Item>
                      ) : (
                        <div
                          style={{
                            transform: "translateY(55px)",
                            width: "25%",
                            height: "46px",
                          }}
                        ></div>
                      )}
                    </div>
                    <div className="couponRow_SecondRow">
                      <Form.Item
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name={"coupon_numbers"}
                        required
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Radio.Group
                          value={couponNumbers}
                          onChange={(e) => {
                            setCouponNumbers(e.target.value);
                          }}
                        >
                          <Space direction="vertical">
                            <Radio
                              style={
                                couponNumbers === "oneCoupon" && checkCoupon
                                  ? {
                                      marginBottom: "130px",
                                    }
                                  : couponNumbers === "oneCoupon"
                                  ? { marginBottom: "100px" }
                                  : { marginBottom: "10px" }
                              }
                              value={"oneCoupon"}
                            >
                              One Coupon Code
                            </Radio>
                            <Radio
                              style={
                                couponNumbers === "oneCoupon"
                                  ? {
                                      marginBottom: "70px",
                                    }
                                  : {}
                              }
                              value={"multipeCoupon"}
                            >
                              Multipe Coupon Code
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                      {couponNumbers === "oneCoupon" && (
                        <>
                          <div className="oneCouponContentWrapper">
                            <Form.Item
                              style={{
                                width: "380px",
                              }}
                              className="formLabel"
                              labelCol={{ span: 24 }}
                              name={"single_coupon_string"}
                              label={
                                <p>
                                  Add One Coupon Code
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "300",
                                    }}
                                  >
                                    &nbsp;(This Coupon can be used once only)
                                  </span>
                                </p>
                              }
                              required
                              rules={[
                                {
                                  required: true,
                                  message: "Enter a valid string",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) => {
                                  setCheckCoupon(false);
                                }}
                                style={{
                                  width: "254px",
                                }}
                                className="formInput"
                              />
                            </Form.Item>
                            {couponAvailable && checkCoupon && (
                              <div className="couponAvailableWrapper">
                                <CloseCircleFilled style={{ color: "red" }} />
                                <p>Not Available,Try another name</p>
                              </div>
                            )}
                            {!couponAvailable && checkCoupon && (
                              <div className="couponAvailableWrapper">
                                <CheckCircleFilled
                                  style={{ color: "rgba(65, 159, 35, 1)" }}
                                />
                                <p>Available</p>
                              </div>
                            )}
                            <Form.Item
                              style={{
                                width: "380px",
                              }}
                              className="formLabel"
                              labelCol={{ span: 24 }}
                              name={"single_coupon_status"}
                              label="Coupon Status"
                              required
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                            >
                              <Select
                                style={{
                                  width: "113px",
                                  height: "41px",
                                }}
                              >
                                <Select.Option value="active">
                                  Active
                                </Select.Option>
                                <Select.Option value="inactive">
                                  Inactive
                                </Select.Option>
                              </Select>
                            </Form.Item>
                            <div
                              style={{
                                display: "flex",
                                position: "absolute",
                                top:
                                  couponNumbers === "oneCoupon" && checkCoupon
                                    ? "155px"
                                    : "135px",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Button
                                loading={loadCreateCoupon}
                                disabled={
                                  loadCreateCoupon || !showcouponSection
                                }
                                onClick={(e) => {
                                  handleCreateCoupon();
                                }}
                                className="createCouponsButton"
                              >
                                Create Coupons
                              </Button>
                              {showSuccessfullCouponCreated && (
                                <div className="couponSuccessMessage">
                                  <CheckCircleFilled
                                    style={{
                                      color: "rgba(65, 159, 35, 1)",
                                    }}
                                  />
                                  <p>Coupon successfuly created</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {couponNumbers === "multipeCoupon" && (
                        <>
                          <div className="multipeCouponContentWrapper">
                            <Form.Item
                              className="formLabel"
                              labelCol={{ span: 24 }}
                              name={"multipeCouponCodeNumber"}
                              label={
                                <p
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  How many coupons
                                </p>
                              }
                              required
                              rules={[
                                {
                                  required: true,
                                  message: "Enter a valid number",
                                },
                              ]}
                              style={{
                                width: "16%",
                              }}
                            >
                              <Input
                                style={{
                                  width: "133px",
                                }}
                                className="formInput"
                              />
                            </Form.Item>
                            <Form.Item
                              className="formLabel"
                              labelCol={{ span: 24 }}
                              name={"multipe_coupon_status"}
                              label="Coupon Status"
                              required
                              rules={[
                                {
                                  required: true,
                                  message: "Enter a valid string",
                                },
                              ]}
                            >
                              <Select
                                style={{
                                  width: "113px",
                                  height: "41px",
                                }}
                              >
                                <Select.Option value="active">
                                  Active
                                </Select.Option>
                                <Select.Option value="inactive">
                                  Inactive
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <Form.Item
                            className="formLabel"
                            labelCol={{ span: 24 }}
                            name={"multipe_coupon_string"}
                            label="Coupon starts with a string:"
                            required
                            style={{
                              transform: "translateX(15px)",
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Enter a valid string",
                              },
                            ]}
                          >
                            <Input
                              onChange={(e) => {
                                setCheckMultipeCoupon(false);
                              }}
                              style={{
                                width: "254px",
                                marginBottom: "35px",
                              }}
                              className="formInput"
                            />
                          </Form.Item>
                          {couponAvailable && checkMultipeCoupon && (
                            <div className="couponAvailableWrapperMultipe">
                              <CloseCircleFilled style={{ color: "red" }} />
                              <p>Not Available,Try another name</p>
                            </div>
                          )}
                          {!couponAvailable && checkMultipeCoupon && (
                            <div className="couponAvailableWrapperMultipe">
                              <CheckCircleFilled
                                style={{
                                  color: "rgba(65, 159, 35, 1)",
                                }}
                              />
                              <p>Available</p>
                            </div>
                          )}
                          <Button
                            onClick={(e) => {
                              handleCreateCoupon();
                            }}
                            loading={loadCreateCoupon}
                            disabled={loadCreateCoupon || !showcouponSection}
                            style={{
                              transform: "translateX(15px)",
                              top: "-10px",
                            }}
                            className="createCouponsButton"
                          >
                            Create Coupons
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                  <TableFilter globalSearch={globalSearchFunction} />
                  <Table
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (e) => {
                          setEditCouponData(record);
                          setOpenEditCoupon(true);
                        },
                      };
                    }}
                    loading={couponsTableLoading}
                    rowClassName="td"
                    columns={couponColumns}
                    dataSource={filteredCouponsData}
                  ></Table>
                  <Divider />
                </>
              )}
              <div className="section2_secondrow">
                <div className="section2_secondrow_left">
                  <Form.Item
                    style={{
                      width: "120%",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"partner_reward_type"}
                    label="What the Influencer will get"
                    required
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      style={{
                        height: "46px",
                        width: "100%",
                      }}
                      onChange={(e) => {
                        setAmountPerUser(e);
                        if (e === "nothing") {
                          form.setFieldsValue({
                            influencer_amount_per_user: undefined,
                          });
                        }
                      }}
                    >
                      <Select.Option value="money">Money</Select.Option>
                      <Select.Option value="percentage">Percentage</Select.Option>
                      <Select.Option value="time">
                        Free Subscription (months)
                      </Select.Option>
                      <Select.Option value="nothing">Nothing</Select.Option>
                    </Select>
                  </Form.Item>
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <Form.Item
                      className="formLabel"
                      labelCol={{ span: 24 }}
                      name={"influencer_amount_per_user"}
                      label="Amount per user"
                      required={amountPerUser === "nothing" ? false : true}
                      style={
                        amountPerUser === "nothing"
                          ? {
                              cursor: "not-allowed",
                            }
                          : {}
                      }
                      rules={
                        amountPerUser === "nothing"
                          ? []
                          : [
                              {
                                required: true,
                                message: "Please enter a valid amount",
                              },
                            ]
                      }
                    >
                      {amountPerUser === "money" && (
                        <InputNumber
                          name="2"
                          className="formInput"
                          style={{
                            width: "100%",
                          }}
                          addonBefore="$"
                          controls={false}
                        />
                      )}
                      {amountPerUser === "percentage" && (
                        <InputNumber
                          name="3"
                          className="formInput"
                          style={{
                            width: "100%",
                          }}
                          addonBefore="%"
                          controls={false}
                        />
                      )}
                      {amountPerUser === "time" && (
                        <Input className="formInput" />
                      )}
                      {amountPerUser === "nothing" && (
                        <Input className="formInput" disabled />
                      )}
                    </Form.Item>
                    <div className="section2_divider"></div>
                  </div>
                </div>

                <div className="section2_secondrow_right">
                  <Form.Item
                    style={{
                      width: "120%",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"customer_reward_type"}
                    label="What the Customer will get"
                    required
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      style={{
                        height: "46px",
                        width: "100%",
                      }}
                      onChange={(e) => {
                        setCustomerAmountPerUser(e);
                        if (e === "nothing") {
                          form.setFieldsValue({
                            customer_amount_per_user: undefined,
                          });
                        }
                      }}
                    >
                      <Select.Option value="percentage">
                        Discount - percentage
                      </Select.Option>
                      {/* <Select.Option value="money">
                        Discount - amount in $
                      </Select.Option> */}
                      <Select.Option value="time">
                        Free Subscription (months)
                      </Select.Option>
                      <Select.Option value="nothing">Nothing</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"customer_amount_per_user"}
                    label="Amount per user"
                    required={
                      customerAmountPerUser === "nothing" ? false : true
                    }
                    style={
                      customerAmountPerUser === "nothing"
                        ? {
                            cursor: "not-allowed",
                          }
                        : {}
                    }
                    rules={
                      customerAmountPerUser === "nothing"
                        ? []
                        : [
                            {
                              required: true,
                              message: "Please enter a valid amount",
                            },
                          ]
                    }
                  >
                    {customerAmountPerUser === "money" && (
                      <InputNumber
                        name="2"
                        className="formInput"
                        style={{
                          width: "100%",
                        }}
                        addonBefore="$"
                        controls={false}
                        // formatter={(value) =>
                        //   `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        // }
                        // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      />
                    )}
                    {customerAmountPerUser === "percentage" && (
                      <InputNumber
                        addonBefore="%"
                        name="1"
                        className="formInput"
                        style={{
                          width: "100%",
                        }}
                        controls={false}
                        // formatter={(value) => {
                        //   // return `${value}%`;
                        //   return `% ${value}`.replace(
                        //     /\B(?=(\d{3})+(?!\d))/g,
                        //     ","
                        //   );
                        // }}
                      />
                    )}
                    {customerAmountPerUser === "time" && (
                      <Input className="formInput" />
                    )}
                    {customerAmountPerUser === "nothing" && (
                      <Input className="formInput" disabled />
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className="section2_thirdrow">
                <Form.Item
                  style={{
                    width: "15%",
                  }}
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"bonus"}
                  label="Bonus"
                  required
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    onChange={(e) => {
                      form.setFieldsValue({
                        bonus_for_each: undefined,
                        bonus_will_get: undefined,
                      });
                      if (e === "no") {
                        setHasBonus(false);
                        setBonusForEach(null);
                      }
                      if (e === "yes") {
                        setHasBonus(true);
                      }
                    }}
                    style={{
                      height: "46px",
                    }}
                  >
                    <Select.Option value="yes">Yes</Select.Option>
                    <Select.Option value="no">No</Select.Option>
                  </Select>
                </Form.Item>
                <p
                  style={{
                    width: "max-content",
                    transform: "translateY(40px)",
                    fontWeight: "500",
                  }}
                >
                  For each
                </p>
                <Form.Item
                  style={
                    hasBonus === false
                      ? {
                          width: "12%",
                          cursor: "not-allowed",
                          transform: "translateY(40px)",
                        }
                      : { width: "12%", transform: "translateY(40px)" }
                  }
                  rules={
                    hasBonus === false
                      ? []
                      : [
                          {
                            required: true,
                            message: "Please enter a valid amount",
                          },
                        ]
                  }
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"bonus_for_each"}
                >
                  <Input
                    disabled={hasBonus === true ? false : true}
                    value={bonusForEach}
                    onChange={(e) => {
                      setBonusForEach(e.target.value);
                    }}
                    className="formInput"
                  />
                </Form.Item>
                <p
                  style={{
                    width: "max-content",
                    transform: "translateY(40px)",
                    fontWeight: "500",
                  }}
                >
                  Successful referral, partner will get
                </p>
                <Form.Item
                  style={
                    hasBonus === false
                      ? {
                          width: "30%",
                          transform: "translateY(40px)",
                          cursor: "not-allowed",
                        }
                      : { width: "30%", transform: "translateY(40px)" }
                  }
                  rules={
                    hasBonus === false
                      ? []
                      : [
                          {
                            required: true,
                            message: "Please enter a valid amount",
                          },
                        ]
                  }
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"bonus_will_get"}
                  disabled={hasBonus === true ? false : true}
                >
                  <InputNumber
                    className="formInput"
                    style={{
                      width: "120px",
                    }}
                    controls={false}
                    addonBefore="$"
                    // formatter={(value) =>
                    //   `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    // }
                    // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
              {!showcouponSection && (
                <>
                  <Divider />
                  <p className="section2Subtitle">Coupon Codes</p>
                  <TableFilter globalSearch={globalSearchFunction} />
                  <Table
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (e) => {
                          setEditCouponData(record);
                          setOpenEditCoupon(true);
                        },
                      };
                    }}
                    loading={couponsTableLoading}
                    rowClassName="td"
                    columns={couponColumns}
                    dataSource={filteredCouponsData}
                  ></Table>
                </>
              )}
              {/* <button
                onClick={(e) => {
                  e.preventDefault();
                  downloadPartnerCouponCSV(userId);
                }}
                style={{
                  background: "green",
                  width: "fit-content",
                  color: "white",
                  borderRadius: "8px",
                  padding: "16px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Export Partner Coupons to CSV
              </button> */}
            </div>
            <Divider />
            <div className="section3">
              <p className="section3Subtitle">Partner Billing Details</p>
              <Form.Item
                className="formLabel"
                labelCol={{ span: 24 }}
                name={"billing_details"}
              >
                <Radio.Group
                  value={billingDetailsChoice}
                  onChange={(e) => {
                    setBillingDetailsChoice(e.target.value);
                    if (e.target.value === 1) {
                      form.setFieldsValue({
                        account_onwer_name: "",
                        country: "",
                        bic: "",
                        iban: "",
                        paypal_account: "",
                      });
                    }
                  }}
                >
                  <Space direction="vertical">
                    <Radio value={1}>Let the partner fill (default)</Radio>
                    <Radio value={2}>Fill for the partner</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>

              {billingDetailsChoice === 2 && (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <FormItem
                    style={{
                      width: "70%",
                      transform: "translateX(25px)",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="currency"
                    label="Currency"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Currency is required",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        height: "46px",
                        width: "15%",
                      }}
                    >
                      <Select.Option value="eur">EUR</Select.Option>
                      <Select.Option value="usd">USD</Select.Option>
                      <Select.Option value="aud">AUD</Select.Option>
                      <Select.Option value="ca$">CAD</Select.Option>
                      <Select.Option value="chf">CHF</Select.Option>
                      <Select.Option value="gpb">GPB</Select.Option>
                      <Select.Option value="jpy">JPY</Select.Option>
                      <Select.Option value="cnh">CNH</Select.Option>
                      <Select.Option value="hkd">HKD</Select.Option>
                      <Select.Option value="nzd">NZD</Select.Option>
                      <Select.Option value="sgd">SGD</Select.Option>
                      <Select.Option value="inr">INR</Select.Option>
                      <Select.Option value="nok">NOK</Select.Option>
                    </Select>
                  </FormItem>
                  <FormItem
                    style={{
                      width: "70%",
                      transform: "translateX(25px)",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="paymentMethod"
                    label="Payment Method"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Payment Method is required",
                      },
                    ]}
                  >
                    <Radio.Group
                      value={paymentMethod}
                      onChange={(e) => {
                        setPaymentMethod(e.target.value);
                        if (paypalChanged) {
                          form.setFieldsValue({
                            account_onwer_name: undefined,
                            country: undefined,
                            bic: undefined,
                            iban: undefined,
                          });
                        }
                        if (
                          bankNameChanged ||
                          countryChanged ||
                          bicChanged ||
                          ibanChanged
                        ) {
                          form.setFieldsValue({
                            paypal_account: undefined,
                          });
                        }
                      }}
                    >
                      <Space direction="vertical">
                        <Radio
                          style={
                            paymentMethod === "paypal"
                              ? {
                                  marginBottom: "120px",
                                }
                              : {}
                          }
                          value={"paypal"}
                        >
                          PayPal
                        </Radio>
                        <Radio value={"bank"}>Bank Transfer</Radio>
                      </Space>
                    </Radio.Group>
                  </FormItem>
                  {paymentMethod === "paypal" && (
                    <FormItem
                      style={{
                        position: "absolute",
                        width: "25%",
                        top: "165px",
                        left: "25px",
                      }}
                      className="formLabel"
                      labelCol={{ span: 24 }}
                      name="paypal_account"
                      label="Paypal Account"
                      required
                      validateTrigger="onBlur"
                      rules={[
                        {
                          required: true,
                          message: "Paypal account is required",
                        },
                        {
                          type: "email",
                          message: "Paypal email is not valid email",
                        },
                      ]}
                    >
                      <Input className="formInput" />
                    </FormItem>
                  )}
                  {paymentMethod === "bank" && (
                    <>
                      <FormItem
                        style={{
                          width: "25%",
                          transform: "translateX(50px)",
                        }}
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name="account_onwer_name"
                        label="Account Owner name"
                        required
                        rules={[
                          {
                            required: true,
                            message: "Account Owner name is required",
                          },
                        ]}
                      >
                        <Input className="formInput" />
                      </FormItem>
                      <div
                        style={{
                          display: "flex",
                          width: "49%",
                          gap: "25px",
                          transform: "translateX(50px)",
                        }}
                      >
                        <FormItem
                          style={{
                            width: "100%",
                          }}
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name="country"
                          label="Country"
                          required
                          rules={[
                            {
                              required: true,
                              message: "Country is required",
                            },
                          ]}
                        >
                          <Input className="formInput" />
                        </FormItem>
                        <FormItem
                          style={{
                            width: "100%",
                          }}
                          className="formLabel"
                          labelCol={{ span: 24 }}
                          name="bic"
                          label="BIC"
                          required
                          rules={[
                            {
                              required: true,
                              message: "BIC is required",
                            },
                          ]}
                        >
                          <Input className="formInput" />
                        </FormItem>
                      </div>
                      <FormItem
                        style={{
                          width: "49%",
                          transform: "translateX(50px)",
                        }}
                        className="formLabel"
                        labelCol={{ span: 24 }}
                        name="iban"
                        label="IBAN"
                        required
                        rules={[
                          {
                            required: true,
                            message: "IBAN is required",
                          },
                        ]}
                      >
                        <Input className="formInput" />
                      </FormItem>
                    </>
                  )}
                </div>
              )}
            </div>
            <Divider />
            <div className="section4">
              <p className="section4Subtitle">Partner's Files</p>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  transform: "translateX(25px)",
                }}
              >
                Upload File Type
              </p>
              <div className="section4UploadContainer">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    width: "100%",
                  }}
                >
                  <Form.Item
                    style={{
                      width: "250px",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"file_type"}
                    label="Choose File Type"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Choose a valid file type",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        height: "46px",
                        // width: "100%",
                      }}
                      value={fileType}
                      onChange={(e) => {
                        setFileType(e);
                        if (e !== "other") {
                          form.setFieldsValue({
                            file_type_other: undefined,
                          });
                        }
                      }}
                    >
                      <Select.Option value="certificateOfInco">
                        Certificate of Incorporation
                      </Select.Option>
                      <Select.Option value="bankAccount">
                        Bank Account Statement
                      </Select.Option>
                      <Select.Option value="contract">Contract</Select.Option>
                      <Select.Option value="other">Other</Select.Option>
                    </Select>
                  </Form.Item>
                  <p
                    style={{
                      transform: "translateY(15px)",
                      width: "50px",
                      fontWeight: "500",
                    }}
                  >
                    Or type
                  </p>
                  <Form.Item
                    style={
                      fileType === "other"
                        ? {
                            width: "250px",
                            transform: "translateY(20px)",
                          }
                        : {
                            cursor: "not-allowed",
                            width: "250px",
                            transform: "translateY(20px)",
                          }
                    }
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"file_type_other"}
                    label=""
                  >
                    <Input
                      disabled={fileType === "other" ? false : true}
                      style={{
                        width: "100%",
                      }}
                      className="formInput"
                    />
                  </Form.Item>
                </div>
                <div className="uploadContainer">
                  <Upload
                    multiple={true}
                    showUploadList={false}
                    style={{
                      width: "150px",
                    }}
                    accept=".pdf, .jpg, .jpeg, .png"
                    beforeUpload={(file) => {
                      const reader = new FileReader();
                      setFiles((prev) => [...prev, file]);
                      if (fileType === "other") {
                        setFilesForRequest((prev) => [
                          ...prev,
                          {
                            fileType: form.getFieldValue("file_type_other"),
                            fileName: file.name,
                          },
                        ]);
                      } else {
                        setFilesForRequest((prev) => [
                          ...prev,
                          { fileType, fileName: file.name },
                        ]);
                      }

                      reader.onload = (e) => {};

                      // Prevent upload
                      return false;
                    }}
                    onRemove={(e) => {
                      setFilesForRequest((prev) => {
                        return prev.filter((file) => {
                          return file.fileName !== e.name;
                        });
                      });
                      setFiles((prev) => {
                        return prev.filter((file) => file.name !== e.name);
                      });
                    }}
                  >
                    <Button
                      style={{
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      Upload
                      <p>Suported Format: PDF, JPG, JPEG, PNG</p>
                    </Button>
                  </Upload>
                  <div>
                    {files.map((item, i) => {
                      return (
                        <div className="uploadListWrapper">
                          <PaperClipOutlined
                            style={{
                              marginRight: "15px",
                            }}
                          />
                          <p
                            style={{
                              position: "relative",
                              left: 0,
                              margin: 0,
                              top: 0,
                            }}
                            key={i}
                          >
                            {item.name}
                          </p>
                          <DeleteOutlined
                            onClick={() => {
                              setFilesForRequest((prev) => {
                                return prev.filter((file) => {
                                  return file.fileName !== item.name;
                                });
                              });
                              setFiles((prev) => {
                                return prev.filter(
                                  (file) => file.name !== item.name
                                );
                              });
                            }}
                            style={{
                              margin: "0 5px 0 auto",
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <Table
                pagination={false}
                dataSource={user?.files?.filter(
                  (file) =>
                    file.id !== "promotion_logo" &&
                    file.id !== "legal_advisor_logo"
                )}
                columns={columns}
              />
            </div>
            <Divider />
            <div className="section5">
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: "50%",
                  }}
                >
                  <p className="section5Subtitle">Account Status</p>
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"account_status"}
                    label="Account Status"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Choose a valid file type",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        height: "46px",
                        width: "40%",
                      }}
                    >
                      <Select.Option value="active">Active</Select.Option>
                      <Select.Option value="inactive">Inactive</Select.Option>
                    </Select>
                  </Form.Item>

                  {/*
                    Whether this partner manages customers.

                    The flag behind the "My Customer" half of the partner
                    header: off, they see only their own demo account. It is
                    set here and nowhere else -- a partner cannot grant it to
                    themselves -- which is why it belongs beside Account
                    Status rather than with the reward settings.
                  */}
                  <p className="section5Subtitle">Customer Management</p>
                  <Checkbox
                    checked={canManageCustomers}
                    onChange={(e) => setCanManageCustomers(e.target.checked)}
                  >
                    This partner can see and manage their customers
                  </Checkbox>
                </div>
                <div
                  style={{
                    width: "60%",
                  }}
                >
                  {paymentMethod === "paypal" && (
                    <>
                      <p className="section5Subtitle">Validate Partner</p>

                      <Checkbox
                        defaultChecked={user.paypal_verified}
                        onChange={(e) => {
                          setPaypalVerified(e.target.checked);
                        }}
                      >
                        Confirm the PayPal account include indication of the
                        partner business/identity
                      </Checkbox>
                      <Checkbox
                        defaultChecked={user.certiticate_name_verified}
                        onChange={(e) => {
                          setPaypalCertiticateNameVerified(e.target.checked);
                        }}
                      >
                        Confirm certificate of incorporation is valid and
                        matching the partner company/brand name
                      </Checkbox>
                    </>
                  )}
                  {paymentMethod === "bank" && (
                    <>
                      <p className="section5Subtitle">Validate Partner</p>

                      <Checkbox
                        onChange={(e) => {
                          setBankDetailsVerified(e.target.checked);
                        }}
                        defaultChecked={user.bank_details_verified}
                      >
                        Confirm the bank details are matching the bank account
                        Statement
                      </Checkbox>
                      <Checkbox
                        onChange={(e) => {
                          setBankCertiticateNameVerified(e.target.checked);
                        }}
                        defaultChecked={user.certiticate_name_verified}
                      >
                        Confirm certificate of incorporation is valid and
                        matching the partner company/brand name
                      </Checkbox>
                      <Checkbox
                        defaultChecked={user.certificate_statement_verified}
                        onChange={(e) => {
                          setCertificateStatementVerified(e.target.checked);
                        }}
                      >
                        Confirm the name of certificate of incorporation is
                        matching the name of the bank account statment
                      </Checkbox>
                    </>
                  )}
                </div>
              </div>
            </div>
            <Divider />
            <div className="section6">
              <Form.Item
                required
                className="formLabel"
                labelCol={{ span: 24 }}
                name={"subscriptionDuration"}
                label="Partner's Subscription plan duration"
              >
                <Radio.Group
                  value={expirationDuration}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "max-content",
                  }}
                  onChange={(e) => {
                    setExpirationDuration(e.target.value);
                  }}
                >
                  <Radio value="six_months">6 Months</Radio>
                  <Radio value="one_year">1 Year</Radio>
                  <Radio value="two_years">2 Years</Radio>
                  <Radio value="custom">Set expiration date</Radio>
                </Radio.Group>
              </Form.Item>
              {expirationDuration === "custom" && (
                <Form.Item
                  style={{
                    position: "absolute",
                    width: "206px",
                    height: "46px",
                    left: "170px",
                    bottom: "-30px",
                  }}
                  name={"custom_subscription_expiration_date"}
                  required
                  rules={[
                    {
                      required: true,
                      message: "choose a valid date",
                    },
                  ]}
                >
                  <DatePicker
                    allowClear={false}
                    style={{
                      width: "206px",
                      height: "46px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    disabledDate={(current) => {
                      let customDate = dayjs().format("YYYY-MM-DD");
                      return (
                        current && current < dayjs(customDate, "YYYY-MM-DD")
                      );
                    }}
                  />
                </Form.Item>
              )}
            </div>
            <Divider />
            {contextHolder}
          </Form>
        </>
      )}
    </Modal>
  );
}

export default EditPartnerForm;
